<template>
  <div>
    <div class="report" id="report">
      <webview
        class="report-wv"
        :style="`height:${dispH - 260}px`"
        :src="`file://${reportHtmlPath}`"
        ref="reportMw"
        @dom-ready="domReady"
      ></webview>
      <div>
        <el-row slot="footer" class="dialog-footer" style="margin-top: 20px">
          <el-button
            :disabled="!isBtnEnabled"
            style="font-size: 28px"
            type="info"
            @click="uploadReport2Dicom"
            >{{ $t("langcfg.txtUploadDICOMServer") }}</el-button
          >
          <el-button
            style="font-size: 28px"
            type="info"
            @click="saveReport2Udisk"
            :disabled="!isBtnEnabled"
            >{{ $t("langcfg.txtPrintToPDF") }}</el-button
          >
          <el-button
            v-if="$i18n.locale === 'zh_CN'"
            :disabled="!isBtnEnabled"
            style="font-size: 28px"
            type="info"
            @click="sendPdfFile2uploadThirdparty"
            >{{ $t("langcfg.txtUpload2Thirdparty") }}</el-button
          >
          <el-button
            style="font-size: 28px"
            type="info"
            @click="saveReport2SharedFolder"
            :disabled="!isBtnEnabled"
            >{{ $t("langcfg.txtPrintToPDF2ShareFolder") }}</el-button
          >
          <el-button
            style="font-size: 28px"
            :disabled="!isBtnEnabled"
            type="info"
            @click="printPDF"
            >{{ $t("langcfg.txtPrint") }}</el-button
          >
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import fileSys from "../../fileoprators/fileSystem";
import Dicom from "../../mainInterface/js/dicom/Dicom";
import {
  getFullName,
  getSystemTime,
  hasKey,
  isDefined,
  isFunction,
  jsGetAge,
  logStdout,
  objectCopy,
  isEqual
} from "../../shared/utils";
import { Message, Size } from "../../mixins";
import { formatDate, paramNormal } from "../../shared/filters";
import { mapGetters } from "vuex";
import GenReportMap from "../js/GenReportMap";
import reportBino from "../js/reportBino";
import printReport from "../../mainInterface/js/printer/print";
import EVENTS from "../../bus";
import {
  cartesian2polar,
  FLATCOLOR,
  STEEPCOLOR,
  isDataValid,
  MAPSTYLES,
  isPointInCircle,
  FILES
} from "../shared/index";
import { MAJMEDIANMODES, PAGES } from "../../shared/consts";
import { forgeDeepCopy, getKeraColor, isFileExists } from "../shared/util";
import DataParams from "../dataGetters/params";
import { Topography3rd } from "../js/thirdparty";
import { normalMapValues } from "../dataGetters/mapValues";
import { getRecordsAll } from "../../services/record";
import { calcElevDiff } from "../js/calc4mmElevDiff";
import FourierCalculate from "../js/FourierCalculate";
import { PDFDocument } from "pdf-lib";
// eslint-disable-next-line no-unused-vars
let ejs = window.require("ejs");
let dicom = new Dicom();
let timeout;
let timeoutWait;
let values = new Array(66);
values.fill(-1000);
let genReportMap;
const KEY = "pupilcorneadia";
export default {
  name: "Report",
  data() {
    return {
      reportHtmlPath: "",
      pdfPath: fileSys.getTopoGrahyReportFilePath(`topographyreport.pdf`),
      paramValues: [],
      greensrc: require("../../assets/img/green.jpg"),
      yellowsrc: require("../../assets/img/yellow.jpg"),
      isBtnEnabled: false,
      isPrinting: false
    };
  },
  props: {
    patient: {
      type: Object
    },
    currentEye: {
      type: String,
      default: "OS"
    },
    record: {
      type: Object,
      default: () => {}
    },
    mapValues: {
      type: Object
    }
  },
  mixins: [Message, Size],
  computed: {
    ...mapGetters(["dateFormat", "zernikeViewParams", "dataShowSettings", "mapDrawSettings"]),
    offset() {
      return window.copyScreen ? 120 : 0;
    },
    RhRfTitle() {
      return this.dataShowSettings.isRhRv ? "Rh" : "Rf";
    },
    RvRsTitle() {
      return this.dataShowSettings.isRhRv ? "Rv" : "Rs";
    },
    eccPEQTitle() {
      let title = "ecc";
      let mode = this.dataShowSettings.medianMode;
      switch (mode) {
        case MAJMEDIANMODES.ecc:
          title = `ecc(${this.dataShowSettings.mm}mm):`;
          break;
        case MAJMEDIANMODES.E:
          title = `E(${this.dataShowSettings.mm}mm):`;
          break;
        case MAJMEDIANMODES.P:
          title = `P(${this.dataShowSettings.mm}mm):`;
          break;
        case MAJMEDIANMODES.Q:
          title = `Q(${this.dataShowSettings.mm}mm):`;
          break;
        default:
          break;
      }
      return title;
    },
    isNewPupil() {
      return (
        this.isContentValid("pupilcorneadia_dark") ||
        this.isContentValid("pupilcorneadia_lowerMiddle") ||
        this.isContentValid("pupilcorneadia_middle") ||
        this.isContentValid("pupilcorneadia_bright") ||
        this.isContentValid("pupilcorneadia_dynamic")
      );
    }
  },

  methods: {
    async loadReport() {
      if (window.printSettings.topography.currentPrintMode === "bino") {
        const data = await reportBino.initData(this.patient, this.record, {
          langcfg: this.$i18n.messages[this.$i18n.locale].langcfg,
          dateFormat: this.dateFormat,
          dataShowSettings: this.dataShowSettings,
          eccPEQTitle: this.eccPEQTitle,
          RhRfTitle: this.RhRfTitle,
          RvRsTitle: this.RvRsTitle,
          printSettings: window.printSettings,
          mapDrawSettings: window.mapDrawSettings
        });
        return this.createReportHtml(data, "bino");
      } else {
        return this.createReportHtml();
      }
    },
    domReady() {
      this.$refs.reportMw.setZoomLevel(4.5);
    },
    getRhRf(params) {
      return paramNormal(this.dataShowSettings.isRhRv ? params["Rh"].value : params["Rf"].value);
    },
    getRvRs(params) {
      return paramNormal(this.dataShowSettings.isRhRv ? params["Rv"].value : params["Rs"].value);
    },
    getCartesianPolar(params, keyX, keyY) {
      if (this.dataShowSettings.isCartesian) {
        return `${paramNormal(params[keyX].value)}mm, ${paramNormal(params[keyY].value)}mm`;
      } else {
        if (isDataValid(params[keyX].value) && isDataValid(params[keyY].value)) {
          let { dist, angle } = cartesian2polar(params[keyX].value, params[keyY].value);
          return `${paramNormal(dist)}mm @ ${paramNormal(angle, {
            fixed: 0,
            rpText: "--"
          })}°`;
        } else {
          return `--mm @ --°`;
        }
      }
    },
    normalParamsData(params) {
      if (!isDefined(params)) return [];
      let paramValues = [];
      let obj = {
        label: `K1/${this.RhRfTitle}:`,
        value: `${paramNormal(params["K1"].value)}D @ ${paramNormal(
          params["AxisFlat"].value
        )}° / ${this.getRhRf(params)}mm`,
        color: FLATCOLOR
      };
      paramValues.push(obj);
      obj = {
        label: `K2/${this.RvRsTitle}:`,
        value: `${paramNormal(params["K2"].value)}D @ ${paramNormal(
          params["AxisSteep"].value
        )}° / ${this.getRvRs(params)} mm`,
        color: STEEPCOLOR
      };
      paramValues.push(obj);
      obj = {
        label: `Km/Rm:`,
        value: `${paramNormal(params["Km"].value)}D / ${paramNormal(params["Rm"].value)}mm`
      };
      paramValues.push(obj);
      let astig = -1000;
      let axis = -1000;
      if (isDataValid(params["K1"].value) && isDataValid(params["K2"].value)) {
        astig = params["K1"].value - params["K2"].value;
      }
      if (isDataValid(params["AxisFlat"].value) && isDataValid(params["AxisSteep"].value)) {
        axis = params["AxisFlat"].value;
      }
      obj = {
        label: `Astig:`,
        value: `${paramNormal(astig)}D / ${paramNormal(axis)}°`
      };
      paramValues.push(obj);
      obj = {
        label: this.eccPEQTitle,
        value: `${paramNormal(params["EccPEQ"].value)}`
      };
      paramValues.push(obj);

      obj = {
        label: `${this.$t("langcfg.txtDiffHightD8")}:`,
        value: `${paramNormal(params["elevDiff4mm"].value, { fixed: 0 })}μm`
      };
      // μm
      paramValues.push(obj);

      obj = {
        label: "Kmax/Rmin:",
        value: `${paramNormal(params["Kmax"].value)}D / ${paramNormal(
          params["Rmin"].value
        )}mm (${this.getCartesianPolar(params, "RminX", "RminY")})`,
        isLong: true
      };
      paramValues.push(obj);

      return paramValues;
    },
    normalKeratoconusParams(params) {
      const KEYS = ["SAI", "SRI", "SDP", "DSI", "OSI", "CSI", "IAI", "KPI", "IS", "KISA"];
      let data = {};
      KEYS.forEach((key) => {
        data[key] = {
          value: paramNormal((params[key] || { value: -1000 }).value),
          color: getKeraColor((params[key] || { value: -1000 }).value, key)
        };
      });
      return data;
    },
    webviewLoaded(ev) {
      this.$bus.$emit(EVENTS.hideGlobalWatting);
    },
    // 制作ejs
    async renderEjs(url, renderobj, callback) {
      try {
        return await ejs.renderFile(url, renderobj);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    isFourMapsPrinted() {
      let flag = false;
      const { FourMaps } = window.printSettings.topography.bino;
      for (const id in FourMaps) {
        if (FourMaps[id]) {
          flag = true;
        }
      }
      return flag;
    },
    isPrintValid() {
      const { Zernike, PupilCornea, Keratoconus } = window.printSettings.topography.bino;
      if (window.printSettings.topography.currentPrintMode === "bino") {
        return this.isFourMapsPrinted() || Zernike || PupilCornea || Keratoconus;
      } else {
        const { FourMaps, Zernike, PupilCornea, Keratoconus } = window.printSettings.topography;
        return FourMaps || Zernike || PupilCornea || Keratoconus;
      }
    },
    async createReportHtml(rpdata, bino) {
      let data = rpdata || this.normalReportData();
      let fourmapHtml = "";
      let fourmapHtmlBino = "";
      let fourieranalysisHtmlBino = "";
      let zernikeHtml = "";
      let pupilcorneaHtml = "";

      let keratoconusHtml = "";
      let heightfandtfsqHtml = "";
      let fourieranalysisHtml = "";
      let compare2recordsHtml = "";
      let headerHtml = "";
      let footerHtml = "";
      let html = "";

      console.log("render data", data);
      console.log("render record", this.record);

      try {
        if (!fileSys.deleteFile(fileSys.getTopoGrahyReportFilePath("topographyreport.html"))) {
          throw new Error("delete html file error");
        }
        if (this.isPrintValid()) {
          if (isDefined(data)) {
            data.checkDoctor = window.printSettings.general.checkdoctor;
            footerHtml = await this.renderEjs(
              fileSys.getTopoGrahyReportFilePath("footer.ejs", bino),
              data
            );
            html = await this.renderEjs(
              fileSys.getTopoGrahyReportFilePath("index.ejs", bino),
              data
            );
            let _title = "";

            const isBino = window.printSettings.topography.currentPrintMode === "bino";
            const isTopography = this.isContentValid("topography");
            const isPupil =
              this.isContentValid("pupilcorneadia_dark") ||
              this.isContentValid("pupilcorneadia_lowerMiddle") ||
              this.isContentValid("pupilcorneadia_middle") ||
              this.isContentValid("pupilcorneadia_bright") ||
              this.isContentValid("pupilcorneadia_dynamic");
            if (
              (!isBino && data.topography.reportName.includes("fourmaps")) ||
              (isBino && data.printFlags.reportName_bino.includes("fourmaps") && isTopography)
            ) {
              _title = window.printSettings.topography.four_maps_title;
              data.title = window.printSettings.general.title_topograpy;
              let splitor =
                window.printSettings.general.title_topograpy !== "" && _title !== "" ? " - " : "";
              if (_title.indexOf("__txt") === 0) {
                _title = this.$t(`langcfg.${_title.replace("__", "")}`);
              }
              data.title = `${data.title}`;
              data._title = _title;
              headerHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("header.ejs", bino),
                data
              );
              let paramsHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("params.ejs", bino),
                data
              );
              fourmapHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("fourmaps.ejs", bino),
                data
              );
              fourmapHtml = fourmapHtml
                .replace("____header____", headerHtml)
                .replace("____params____", paramsHtml)
                .replace("____footer____", footerHtml);
              if (isBino) {
                fourmapHtmlBino = await this.renderEjs(
                  fileSys.getTopoGrahyReportFilePath("fourmapstwo.ejs", bino),
                  data
                );
                fourmapHtmlBino = fourmapHtmlBino
                  .replace("____header____", headerHtml)
                  .replace("____footer____", footerHtml);
              }
            }

            if (
              (!isBino && data.topography.reportName.includes("zernike")) ||
              (isBino && data.printFlags.reportName_bino.includes("zernike") && isTopography)
            ) {
              _title = window.printSettings.topography.zernike_title;
              data.title = window.printSettings.general.title_topograpy;
              let splitor =
                window.printSettings.general.title_topograpy !== "" && _title !== "" ? " - " : "";
              if (_title.indexOf("__txt") === 0) {
                _title = this.$t(`langcfg.${_title.replace("__", "")}`);
              }
              data.title = `${data.title}`;
              data._title = _title;
              headerHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("header.ejs", bino),
                data
              );
              zernikeHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("abberation.ejs", bino),
                data
              );
              zernikeHtml = zernikeHtml
                .replace("____header____", headerHtml)
                .replace("____footer____", footerHtml);
            }
            if (
              (!isBino && data.topography.reportName.includes("keratoconus")) ||
              (isBino && data.printFlags.reportName_bino.includes("keratoconus") && isTopography)
            ) {
              _title = window.printSettings.topography.keratoconus_title;
              data.title = window.printSettings.general.title_topograpy;
              let splitor =
                window.printSettings.general.title_topograpy !== "" && _title !== "" ? " - " : "";
              if (_title.indexOf("__txt") === 0) {
                _title = this.$t(`langcfg.${_title.replace("__", "")}`);
              }
              data.title = `${data.title}`;
              data._title = _title;
              headerHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("header.ejs", bino),
                data
              );
              keratoconusHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("keratoconus.ejs", bino),
                data
              );
              keratoconusHtml = keratoconusHtml
                .replace("____header____", headerHtml)
                .replace("____footer____", footerHtml);
            }
            // if ((!isBino && data.printFlags.Zernike) || (isBino && window.printSettings.topography.bino.Zernike)) {
            if (
              (!isBino && data.topography.reportName.includes("pupilcorneadiameter")) ||
              (isBino && data.printFlags.reportName_bino.includes("pupilcorneadiameter"))
            ) {
              data.backgrounds = { green: this.greensrc, yellow: this.yellowsrc };

              _title = window.printSettings.topography.pupil_cornea_title;
              data.title = window.printSettings.general.title_topograpy;
              let splitor =
                window.printSettings.general.title_topograpy !== "" && _title !== "" ? " - " : "";
              if (_title.indexOf("__txt") === 0) {
                _title = this.$t(`langcfg.${_title.replace("__", "")}`);
              }
              data.title = `${data.title}`;
              data._title = _title;
              headerHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("header.ejs", bino),
                data
              );
              pupilcorneaHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("pupilcornea.ejs", bino),
                data
              );
              pupilcorneaHtml = pupilcorneaHtml
                .replace("____header____", headerHtml)
                .replace("____footer____", footerHtml);
            }
            if (
              (!isBino && data.topography.reportName.includes("heightfandtfsq")) ||
              (isBino && data.printFlags.reportName_bino.includes("heightfandtfsq") && isTopography)
            ) {
              _title = window.printSettings.topography.heightf_tfsq_title;
              data.title = window.printSettings.general.title_topograpy;
              let splitor =
                window.printSettings.general.title_topograpy !== "" && _title !== "" ? " - " : "";
              if (_title.indexOf("__txt") === 0) {
                _title = this.$t(`langcfg.${_title.replace("__", "")}`);
              }
              data.title = `${data.title}`;
              data._title = _title;
              headerHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("header.ejs", bino),
                data
              );
              heightfandtfsqHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("heightfandtfsq.ejs", bino),
                data
              );
              heightfandtfsqHtml = heightfandtfsqHtml
                .replace("____header____", headerHtml)
                .replace("____footer____", footerHtml);
            }
            if (
              (!isBino && data.printFlags.reportName.includes("fourieranalysis")) ||
              (isBino &&
                data.printFlags.reportName_bino.includes("fourieranalysis") &&
                isTopography)
            ) {
              _title = window.printSettings.topography.fourier_analysis_title;
              data.title = window.printSettings.general.title_topograpy;
              let splitor =
                window.printSettings.general.title_topograpy !== "" && _title !== "" ? " - " : "";
              if (_title.indexOf("__txt") === 0) {
                _title = this.$t(`langcfg.${_title.replace("__", "")}`);
              }
              data.title = `${data.title}`;
              data._title = _title;
              headerHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("header.ejs", bino),
                data
              );

              fourieranalysisHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("fourieranalysis.ejs", bino),
                data
              );
              fourieranalysisHtml = fourieranalysisHtml
                .replace("____header____", headerHtml)
                .replace("____footer____", footerHtml);
              if (isBino) {
                fourieranalysisHtmlBino = await this.renderEjs(
                  fileSys.getTopoGrahyReportFilePath("fourieranalysistwo.ejs", bino),
                  data
                );
                fourieranalysisHtmlBino = fourieranalysisHtmlBino
                  .replace("____header____", headerHtml)
                  .replace("____footer____", footerHtml);
              }
            }
            if (!isBino && data.topography.reportName.includes("compare2records")) {
              _title = window.printSettings.topography.compare2records_title;
              data.title = window.printSettings.general.title_topograpy;
              let splitor =
                window.printSettings.general.title_topograpy !== "" && _title !== "" ? " - " : "";
              if (_title.indexOf("__txt") === 0) {
                _title = this.$t(`langcfg.${_title.replace("__", "")}`);
              }
              data.title = `${data.title}`;
              data._title = _title;
              headerHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("header.ejs", bino),
                data
              );
              compare2recordsHtml = await this.renderEjs(
                fileSys.getTopoGrahyReportFilePath("compare2records.ejs", bino),
                data
              );
              compare2recordsHtml = compare2recordsHtml
                .replace("____header____", headerHtml)
                .replace("____footer____", footerHtml);
            }
            html = html.replace("____fourmaps____", fourmapHtml);
            if (isBino) html = html.replace("____fourmapstwo____", fourmapHtmlBino);
            html = html.replace("____zernike____", zernikeHtml);
            html = html.replace("____keratoconus____", keratoconusHtml);
            html = html.replace("____pupilcornea____", pupilcorneaHtml);
            html = html.replace("____heightfandtfsq____", heightfandtfsqHtml);
            html = html.replace("____fourieranalysis____", fourieranalysisHtml);
            if (isBino) html = html.replace("____fourieranalysistwo____", fourieranalysisHtmlBino);
            html = html.replace("____compare2records____", compare2recordsHtml);

            fileSys.writeFileSync(
              fileSys.getTopoGrahyReportFilePath("topographyreport.html", bino),
              html
            );
            this.reportHtmlPath = "";
            this.$nextTick(
              () =>
                (this.reportHtmlPath = fileSys.getTopoGrahyReportFilePath(
                  "topographyreport.html",
                  bino
                ))
            );
          } else {
            this.reportHtmlPath = "";
            this.$nextTick(
              () =>
                (this.reportHtmlPath = fileSys.getTopoGrahyReportFilePath(
                  `error.html?failedTxt=${this.$t("langcfg.txtCreateReportFailed")}`,
                  bino
                ))
            );
          }
        } else {
          this.reportHtmlPath = "";
          this.$nextTick(
            () =>
              (this.reportHtmlPath = fileSys.getTopoGrahyReportFilePath(
                `error.html?failedTxt=${this.$t("langcfg.txtReportWidthoutItem")}`,
                bino
              ))
          );
        }
      } catch (e) {
        console.log(e);
        this.reportHtmlPath = fileSys.getTopoGrahyReportFilePath(
          `error.html?failedTxt=${this.$t("langcfg.txtCreateReportFailed")}`,
          bino
        );
      } finally {
        this.$emit("hide-waiting");
        this.isBtnEnabled = true;
      }
    },
    stopPrintReport(callback) {},
    beforeBtnEvent: function (txt, forever = false) {
      this.isBtnEnabled = false;
      this.$bus.$emit(EVENTS.showGlobalWatting, txt, 50, forever);
    },
    afterBtnEvent: function () {
      this.$bus.$emit(EVENTS.hideGlobalWatting);
      this.isBtnEnabled = true;
      this.isPrinting = false;
    },
    // ------------------button events ------------------
    convertPdfFile: function (pdfPath, callback) {
      fileSys.deleteFile(pdfPath);
      this.$refs.reportMw.getWebContents().printToPDF(
        {
          pageSize: "A4"
        },
        (error, data) => {
          if (error) {
            if (callback) callback(error);
          } else {
            fileSys.writeFile(pdfPath, data, async (error) => {
              if (callback) callback(error, await PDFDocument.load(data));
            });
          }
        }
      );
    },
    uploadReport2Dicom: function () {
      this.beforeBtnEvent(undefined, true);
      const pdfPath = fileSys.getDicomTmpFilePath(`report.pdf`);
      this.convertPdfFile(pdfPath, (error) => {
        if (error) {
          this.message(this.$t("langcfg.txtUploadPdfFailed"), "error", 2000);
        } else {
          const { format, singlepage } = window.printSettings.general;
          if (window.printSettings.general.format !== ".pdf") {
            let tmpImageDir = fileSys.getDicomTmpFilePath("images");
            let imagePath = fileSys.combinePath(tmpImageDir, `report${format}`);
            if (!fileSys.isFileExists(tmpImageDir)) {
              fileSys.mkdirSync(tmpImageDir);
            }
            fileSys.convertPDF2Image(pdfPath, imagePath, { singlepage }, (error) => {
              if (error) {
                this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
              } else {
                dicom.uploadImage2DicomSvr(this.patient, this.record, tmpImageDir);
              }
            });
          } else {
            dicom.uploadPdf2DicomSvr(this.patient, pdfPath, this.record);
          }
        }
      });
    },
    saveReport2Udisk() {
      const { status, location } = fileSys.isUDiskExits();
      if (!status) {
        this.message(this.$t("langcfg.txtDiskIsMountedFailed"), "error", 10000);
      } else {
        this.beforeBtnEvent();
        const { format, singlepage } = window.printSettings.general;
        let eye =
          window.printSettings.topography.currentPrintMode === "bino" ? "ODOS" : this.currentEye;
        let pdfName = fileSys.normalExportName(
          window.exportOptionSettings.folderName,
          this.patient,
          this.record,
          eye,
          this.$i18n.messages[this.$i18n.locale].langcfg
        );
        let pdfPath =
          window.printSettings.general.format === ".pdf"
            ? fileSys.combinePath(location, `${pdfName}.pdf`)
            : fileSys.getDicomTmpFilePath(`${pdfName}.pdf`);
        const imagePath = fileSys.combinePath(location, `${pdfName}${format}`);
        this.convertPdfFile(pdfPath, (error) => {
          if (error) {
            this.afterBtnEvent();
            this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
            return;
          }
          if (window.printSettings.general.format !== ".pdf") {
            fileSys.convertPDF2Image(pdfPath, imagePath, { singlepage }, (error) => {
              this.afterBtnEvent();
              if (error) {
                this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
              } else {
                this.message(this.$t("langcfg.txtSavePDFSuccess"), "success", 2000);
              }
            });
          } else {
            this.afterBtnEvent();
            this.message(this.$t("langcfg.txtSavePDFSuccess"), "success", 2000);
          }
        });
      }
    },
    sendPdfFile2uploadThirdparty() {
      if (
        window.thirdPartySettings &&
        window.thirdPartySettings.auto.value &&
        window.thirdpartyScript &&
        this.patient.thirdData
      ) {
        this.beforeBtnEvent(this.$t("langcfg.txtpdf2server"));
        let pdfPath = fileSys.getUtilPath("thirdparty/topographicReportPdf.pdf");
        if (fileSys.isFileExists(pdfPath)) {
          fileSys.deleteFile(pdfPath);
        }
        this.convertPdfFile(pdfPath, () => {
          window.thirdpartyScript.sendTopgraphicDataAndImages(
            this.patient,
            this.record,
            this.currentEye,
            {
              images: {
                topographicReportPdf: {
                  pdfPath,
                  filename: "topographicReportPdf"
                }
              }
            },
            (res) => {
              this.afterBtnEvent();
              this.message(
                `${res.message}${res.detail ? ":" + res.detail : ""}`,
                res.code === 200 ? "success" : "error"
              );
            },
            this.$t("langcfg.txtpdf2server")
          );
        });
      } else {
        this.message(this.$t("langcfg.txtUploadPdfFailed"), "error", 2000);
      }
    },
    getBatchNo() {
      let now = parseInt(Date.now() / 1000);
      let start = parseInt(new Date("1970-01-01").valueOf() / 1000);
      return now - start;
    },
    uploadIntact(inspectId, batchNo) {
      window.thirdpartyScript.uploadIntact(inspectId, batchNo, (res) => {
        this.afterBtnEvent();
        this.message(
          `${res.message}${res.detail ? ":" + res.detail : ""}`,
          res.code === 200 ? "success" : "error"
        );
      });
    },
    uploadThirdparty(Eye, casePath, callback) {
      if (
        window.thirdPartySettings &&
        window.thirdPartySettings.auto.value &&
        window.thirdpartyScript &&
        this.patient.thirdData &&
        window.settings.thirdparty.copmany === "owl" &&
        this.record.content[`data${Eye}`].diagnosed
      ) {
        let dataparams = new DataParams(casePath);
        let topography3rd = new Topography3rd(this.patient, this.record, casePath, Eye);
        let filepath = fileSys.getUtilPath("thirdparty/topographicReportPdf.pdf");
        if (fileSys.isFileExists(filepath)) {
          fileSys.deleteFile(filepath);
        }
        setTimeout(() => {
          this.convertPdfFile(filepath, () => {
            let set = this.dataShowSettings;
            let mapValues = normalMapValues(dataparams, Eye, set.medianMode, set.mm);
            let { frontpValOfMajMeridians, isShowGrayF } = mapValues;
            let eccAll = dataparams.getMajMedianWithoutGray(
              frontpValOfMajMeridians,
              isShowGrayF,
              mapValues.params["AxisFlat"].value,
              MAJMEDIANMODES.ecc
            );
            let flatE6mm =
              eccAll[4].nas && eccAll[4].temp
                ? (Number(eccAll[4].nas.toFixed(2)) + Number(eccAll[4].temp.toFixed(2))) / 2
                : "--";
            let steepE6mm =
              eccAll[4].inf && eccAll[4].sup
                ? (Number(eccAll[4].inf.toFixed(2)) + Number(eccAll[4].sup.toFixed(2))) / 2
                : "--";
            let flatE8mm =
              eccAll[6].nas && eccAll[6].temp
                ? (Number(eccAll[6].nas.toFixed(2)) + Number(eccAll[6].temp.toFixed(2))) / 2
                : "--";
            let steepE8mm =
              eccAll[6].inf && eccAll[6].sup
                ? (Number(eccAll[6].inf.toFixed(2)) + Number(eccAll[6].sup.toFixed(2))) / 2
                : "--";
            mapValues.params["flatE6mm"] = flatE6mm;
            mapValues.params["steepE6mm"] = steepE6mm;
            mapValues.params["flatE8mm"] = flatE8mm;
            mapValues.params["steepE8mm"] = steepE8mm;
            let coe = window.magecoe.pupilcornea;
            let pupilDia, corneaDia, photo, edgePupil, edgeCornea;
            let pupilcorneadiaKey;
            if (
              (this.record.content[`data${Eye}`].pupilcorneadia &&
                this.record.content[`data${Eye}`]["pupilcorneadia"].diagnosed) ||
              (this.record.content[`data${Eye}`].pupilcorneadia_dark &&
                this.record.content[`data${Eye}`]["pupilcorneadia_dark"].diagnosed)
            ) {
              pupilcorneadiaKey =
                this.record.content[`data${Eye}`].pupilcorneadia_dark &&
                this.record.content[`data${Eye}`]["pupilcorneadia_dark"].diagnosed
                  ? "pupilcorneadia_dark"
                  : "pupilcorneadia";
            }

            if (pupilcorneadiaKey) {
              let pupil = this.record.content[`data${Eye}`][pupilcorneadiaKey].pupildia;
              let cornea = this.record.content[`data${Eye}`][pupilcorneadiaKey].corneadia;
              if (isDefined(pupil.edge) && isDataValid(pupil.edge.r) && pupil.edge.r > 0) {
                let edgeMoved = pupil.edgeMoved;
                let edge =
                  isDefined(edgeMoved) && isDataValid(edgeMoved.r) && edgeMoved.r > 0
                    ? edgeMoved
                    : pupil.edge;
                edgePupil = edge;
              }
              if (isDefined(cornea.edge) && isDataValid(cornea.edge.r) && cornea.edge.r > 0) {
                let edgeMoved = cornea.edgeMoved;
                let edge =
                  isDefined(edgeMoved) && isDataValid(edgeMoved.r) && edgeMoved.r > 0
                    ? edgeMoved
                    : cornea.edge;
                edgeCornea = edge;
              }
              pupilDia = (edgePupil.r * 2 * coe)._toFixed(2);
              corneaDia = (edgeCornea.r * 2 * coe)._toFixed(2);
              photo = this.record.content[`data${Eye}`][pupilcorneadiaKey]["photos"][0];
            } else {
              pupilDia = "--";
              corneaDia = "--";
            }
            if (
              this.record.content[`data${Eye}`].topography &&
              this.record.content[`data${Eye}`]["topography"].diagnosed
            ) {
              topography3rd.normalParamsData(mapValues.params, null, (error, params, images) => {
                if (error) {
                  this.message("create params data failed", "error");
                  // this.afterBtnEvent()
                  if (callback) callback({ message: "Failed" });
                  return;
                }
                logStdout("start send params data and images:", params, images);
                Object.assign(images, {
                  topographicReportPdf: {
                    filepath,
                    filename: "topographicReportPdf"
                  }
                });
                window.thirdpartyScript.sendTopgraphicDataAndImages(
                  this.patient,
                  this.record,
                  Eye,
                  {
                    images,
                    params
                  },
                  (res) => {
                    this.record.content[`data${Eye}`].inspectId = res.inspectId;
                    this.$bus.$emit(EVENTS.updateData, this.record, {}, {}, () => {});
                    if (!pupilcorneadiaKey) {
                      if (callback) callback({ message: "OK" });
                    } else {
                      topography3rd.normalParamsData(
                        null,
                        {
                          pupilDiameter: pupilDia,
                          corneaDiameter: corneaDia,
                          file: photo
                        },
                        (error, params, images) => {
                          if (error) {
                            this.message("pupil cornea params error", "error");
                            // this.afterBtnEvent()
                            if (callback) callback({ message: "Failed" });
                            return;
                          }
                          logStdout("start send pupilcornea data and images:", params, images);
                          window.thirdpartyScript.sendTopgraphicDataAndImages(
                            this.patient,
                            this.record,
                            Eye,
                            {
                              params,
                              images
                            },
                            (res) => {
                              this.record.content[`data${Eye}`].inspectId = res.inspectId;
                              this.$bus.$emit(EVENTS.updateData, this.record, {}, {}, () => {});
                              if (callback) callback({ message: "OK" });
                            },
                            this.$t("langcfg.txtpdf2server")
                          );
                        }
                      );
                    }
                  },
                  this.$t("langcfg.txtpdf2server")
                );
              });
            } else if (pupilcorneadiaKey) {
              topography3rd.normalParamsData(
                null,
                {
                  pupilDiameter: pupilDia,
                  corneaDiameter: corneaDia,
                  file: photo
                },
                (error, params, images) => {
                  if (error) {
                    this.message("pupil cornea params error", "error");
                    // this.afterBtnEvent()
                    if (callback) callback({ message: "Failed" });
                    return;
                  }
                  logStdout("start send pupilcornea data and images:", params, images);
                  Object.assign(images, {
                    topographicReportPdf: {
                      filepath,
                      filename: "topographicReportPdf"
                    }
                  });
                  window.thirdpartyScript.sendTopgraphicDataAndImages(
                    this.patient,
                    this.record,
                    Eye,
                    {
                      params,
                      images
                    },
                    (res) => {
                      this.record.content[`data${Eye}`].inspectId = res.inspectId;
                      this.$bus.$emit(EVENTS.updateData, this.record, {}, {}, () => {});
                      if (callback) callback({ message: "OK" });
                    },
                    this.$t("langcfg.txtpdf2server")
                  );
                }
              );
            }
          });
        }, 2000);
      } else {
        if (callback) callback({ message: "PASS" });
      }
    },
    saveReport2SharedFolder() {
      let { ip, folder, username, password } = window.settings.sharedFolder;
      logStdout("shared folder info:", window.settings.sharedFolder);
      fileSys.mountSharedFS([`${ip}/${folder}`, `${username}`, `${password}`], (error) => {
        if (error) {
          this.message(this.$t("langcfg.txtSharedFolderMountFailed"), "error", 2000);
        } else {
          this.beforeBtnEvent();
          const { format, singlepage } = window.printSettings.general;
          const { folderInLinux } = window.settings.sharedFolder;
          let eye =
            window.printSettings.topography.currentPrintMode === "bino" ? "ODOS" : this.currentEye;
          let pdfName = fileSys.normalExportName(
            window.exportOptionSettings.folderName,
            this.patient,
            this.record,
            eye,
            this.$i18n.messages[this.$i18n.locale].langcfg
          );
          let pdfPath =
            window.printSettings.general.format === ".pdf"
              ? fileSys.combinePath(folderInLinux, `${pdfName}.pdf`)
              : fileSys.getDicomTmpFilePath(`${pdfName}.pdf`);
          const imagePath = fileSys.combinePath(folderInLinux, `${pdfName}${format}`);
          this.convertPdfFile(pdfPath, (error) => {
            if (error) {
              this.afterBtnEvent();
              this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
            } else {
              if (window.printSettings.general.format !== ".pdf") {
                fileSys.convertPDF2Image(pdfPath, imagePath, { singlepage }, (error) => {
                  this.afterBtnEvent();
                  if (error) {
                    this.message(this.$t("langcfg.txtSavePDFFailed"), "error", 2000);
                  } else {
                    this.message(this.$t("langcfg.txtSavePDFSuccess"), "success", 2000);
                  }
                });
              } else {
                this.afterBtnEvent();
                this.message(this.$t("langcfg.txtSavePDFSuccess"), "success", 2000);
              }
            }
          });
        }
      });
    },
    printPDF: function () {
      if (this.isPrinting) {
        this.message(this.$t("langcfg.txtFrequent"), "error");
        return;
      }
      let pdfPath = fileSys.getDicomTmpFilePath("report.pdf");
      this.isBtnEnabled = false;
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtPrintLoading"), null, true);
      this.convertPdfFile(pdfPath, (error, pdf) => {
        if (error) {
          this.isPrinting = false;
          this.message(this.$t("langcfg.txtPrintFailed"), "error", 2000);
          this.afterBtnEvent();
        } else {
          this.isPrinting = true;
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            const { printConnection } = window.printSettings;
            printReport({ pdfPath, printConnection, sizes: pdf.getPageCount() }, (error) => {
              console.log(error);
              this.afterBtnEvent();
              if (isDefined(error)) {
                switch (error.status) {
                  case "no_printer":
                    this.message(this.$t("langcfg.txtPrintNoPrinter"), "error", 0);
                    break;
                  case "not_default_printer":
                    this.message(this.$t("langcfg.txtPrintNotDefaultPrinter"), "error", 0);
                    break;
                  case "not_switch_printer":
                    this.message(this.$t("langcfg.txtPrintNotSwitchPrinter"), "error", 0);
                    break;
                  case "get_state_error":
                    this.message(this.$t("langcfg.txtPrintGetStateError"), "error", 0);
                    break;
                  case "empty":
                    this.message(this.$t("langcfg.txtPrintNoPaper"), "error", 0);
                    break;
                  case "cancel":
                    this.message(this.$t("langcfg.txtPrintCancel"), "error", 0);
                    break;
                  default:
                    this.message(
                      this.$t("langcfg.txtPrintError", { error: error.Status || error }),
                      "error",
                      0
                    );
                    break;
                }
              } else if (printConnection !== "printer-USB") {
                this.message(this.$t("langcfg.txtPrintSuccess"), "success", 5000);
              }
              setTimeout(() => {
                this.isPrinting = false;
              }, 5000);
            });
          }, 1000);
        }
      });
    },
    // ------------------------------------------------

    isContentValid(key) {
      let _key = key || KEY;
      return (
        isDefined(this.record) &&
        isDefined(this.record.content) &&
        isDefined(this.record.content[`data${this.currentEye}`]) &&
        isDefined(this.record.content[`data${this.currentEye}`][_key]) &&
        this.record.content[`data${this.currentEye}`][_key].diagnosed
      );
    },
    isModeDataValid(key, mode) {
      return (
        this.isContentValid(key) &&
        isDefined(this.record.content[`data${this.currentEye}`][key]) &&
        isDefined(this.record.content[`data${this.currentEye}`][key][mode])
      );
    },
    initData() {
      let data = {
        isDiameter: window.dataShowSettings.isDiameter,
        isCartesian: window.dataShowSettings.isCartesian
      };
      genReportMap = null;
      data.hospitalInfo = objectCopy(window.printSettings.general);
      data.hospitalInfo.logoPath = fileSys.getCfgPath(data.hospitalInfo.hospitallogo);

      data.topography = objectCopy(window.printSettings.topography);
      data.hospitalInfo.title_topograpy =
        window.printSettings.general.title_topograpy === "Report"
          ? this.$t("langcfg.txtReport")
          : window.printSettings.general.title_topograpy;
      data.printFlags = objectCopy(window.printSettings.topography);
      data.eye = this.currentEye || "--";
      data.langcfg = this.$i18n.messages[this.$i18n.locale].langcfg;
      data.printDate = formatDate(getSystemTime(), this.dateFormat, true);
      data.params = this.normalParamsData(this.mapValues.params);
      data.keraParams = this.normalKeratoconusParams(this.mapValues.params);
      data.printSettings = window.printSettings;
      data.pupilcornea = window.magecoe.pupilcornea;
      let fourmapsDrawSettings = window.mapDrawSettings.fourmaps;
      data.patientInfo = {
        name: window.__ct__.debug ? "Test" : "",
        pid: window.__ct__.debug ? "000000001" : "",
        sex: window.__ct__.debug ? "Male" : "",
        age: window.__ct__.debug ? "29" : "",
        birthday: window.__ct__.debug ? "1988-12-10" : "",
        checkDate: window.__ct__.debug ? "2018-10-10" : ""
      };
      data.fourMaps = {
        tCurvature: {
          cliPath: fourmapsDrawSettings.mapInForm0.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: fourmapsDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          dia: fourmapsDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12
        },
        sCurvature: {
          cliPath: fourmapsDrawSettings.mapInForm1.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: fourmapsDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          dia: fourmapsDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? 9 : 12
        },
        elevation: {
          cliPath: fourmapsDrawSettings.mapInForm2.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: fourmapsDrawSettings.mapInForm2.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          dia: fourmapsDrawSettings.mapInForm2.shapes.ShowDiameter9mm ? 9 : 12
        },
        frp: {
          cliPath: fourmapsDrawSettings.mapInForm3.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: fourmapsDrawSettings.mapInForm3.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          dia: fourmapsDrawSettings.mapInForm3.shapes.ShowDiameter9mm ? 9 : 12
        }
      };
      let largemapSettings = window.mapDrawSettings.largemap;
      data.heightFAndTFSQ = {
        heightF: {
          cliPath: largemapSettings.mapInForm0.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: largemapSettings.mapInForm0.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          dia: largemapSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12
        },
        tfsq: {
          cliPath: largemapSettings.mapInForm0.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: largemapSettings.mapInForm0.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          dia: largemapSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12
        }
      };
      let fourierAnalysisSettings = window.mapDrawSettings.fourierAnalysis;
      data.fourierAnalysis = {
        sphericalComponent: {
          cliPath: fourierAnalysisSettings.mapInForm0.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: fourierAnalysisSettings.mapInForm0.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          dia: fourierAnalysisSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12
        },

        decentration: {
          cliPath: fourierAnalysisSettings.mapInForm1.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: fourierAnalysisSettings.mapInForm1.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          dia: fourierAnalysisSettings.mapInForm1.shapes.ShowDiameter9mm ? 9 : 12
        },
        regularAstigmatism: {
          cliPath: fourierAnalysisSettings.mapInForm3.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: fourierAnalysisSettings.mapInForm3.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          dia: fourierAnalysisSettings.mapInForm3.shapes.ShowDiameter9mm ? 9 : 12
        },
        irregularity: {
          cliPath: fourierAnalysisSettings.mapInForm4.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: fourierAnalysisSettings.mapInForm4.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          dia: fourierAnalysisSettings.mapInForm4.shapes.ShowDiameter9mm ? 9 : 12
        },
        paramsSph: {},
        paramsDecent: {},
        paramsRegular: {},
        paramsIrregular: {}
      };
      let keratoconusDrawSettings = window.mapDrawSettings.keratoconus;
      data.keratoconus = {
        sCurvature: {
          cliPath: keratoconusDrawSettings.mapInForm0.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: keratoconusDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          axisMap: "",
          dia: keratoconusDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12
        },
        elevation: {
          cliPath: keratoconusDrawSettings.mapInForm1.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: keratoconusDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          axisMap: "",
          dia: keratoconusDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? 9 : 12
        }
      };
      data.aberration = {
        params: [],
        svgPath: fileSys.getCfgPath("img/zernikes/"),
        values: values,
        zernikeSet: window.zernikeSet,
        map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
        colorBarURL: window.__ct__.debug
          ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
          : "",
        maxPeak: { x: "--", y: "--" },
        meanRms: { mean: "--", rms: "--" },
        retinal: {
          image: window.__ct__.debug ? fileSys.getMockPath("E.bmp").replace(/\\/g, "\\\\") : "",
          title: "retinal"
        },
        psf: {
          image: window.__ct__.debug ? fileSys.getMockPath("E.bmp").replace(/\\/g, "\\\\") : "",
          title: "psf",
          label: "fdf"
        },
        chart: {
          image: window.__ct__.debug ? fileSys.getMockPath("E.bmp") : "",
          title: "chart"
        }
      };
      let compare2recordsDrawSettings = window.mapDrawSettings.compare2records;
      data.compare2records = {
        contrastParamsOne: "",
        contrastParamsTwo: "",
        contrastParamsDiff: "",
        contrastParamsOneTitle: "",
        contrastParamsTwoTitle: "",
        contrastParamsDiffTitle: "",
        contrastone: {
          cliPath: compare2recordsDrawSettings.mapInForm0.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: compare2recordsDrawSettings.mapInForm0.shapes.ShowDiameter9mm
            ? "trans"
            : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          axisMap: "",
          dia: compare2recordsDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12
        },
        contrasttwo: {
          cliPath: compare2recordsDrawSettings.mapInForm1.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: compare2recordsDrawSettings.mapInForm1.shapes.ShowDiameter9mm
            ? "trans"
            : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          axisMap: "",
          dia: compare2recordsDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? 9 : 12
        },
        difference: {
          cliPath: compare2recordsDrawSettings.mapInForm2.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: compare2recordsDrawSettings.mapInForm2.shapes.ShowDiameter9mm
            ? "trans"
            : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
          colorBarURL: window.__ct__.debug
            ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
            : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: "",
          axisMap: "",
          dia: compare2recordsDrawSettings.mapInForm2.shapes.ShowDiameter9mm ? 9 : 12
        }
      };
      data.pupilCornea = {
        ...(this.isNewPupil
          ? { dark: {}, lowerMiddle: {}, middle: {}, bright: {}, corneadia: {}, seriesData: "" }
          : { cornea: {}, pupil: {} }),
        isNewPupil: this.isNewPupil,
        dist: "--",
        image: window.__ct__.debug ? fileSys.getMockPath("map.jpg") : "",
        circleImage: ""
      };
      return data;
    },
    drawPupilCenter(edgePupil, edgeCornea, data) {
      let canvas = document.createElement("canvas");
      canvas.width = 2048;
      canvas.height = 1536;
      // draw pupil
      let ctx = canvas.getContext("2d");
      ctx.lineWidth = 4;
      ctx.font = `50px arial`;
      ctx.setLineDash([10, 10]);
      if (edgePupil && isDataValid(edgePupil.r)) {
        ctx.save("translate");
        ctx.translate(edgePupil.x, edgePupil.y);
        ctx.strokeStyle = "#0f0";
        ctx.beginPath();
        ctx.arc(0, 0, edgePupil.r, 0, 2 * Math.PI, true);
        ctx.stroke();

        ctx.lineWidth = 3;
        ctx.setLineDash([6, 5]);
        ctx.beginPath();
        ctx.moveTo(-20, 0);
        ctx.lineTo(20, 0);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(0, -20);
        ctx.lineTo(0, 20);
        ctx.stroke();
        ctx.restore("translate");
      }
      ctx.lineWidth = 4;
      if (edgeCornea && isDataValid(edgeCornea.r)) {
        // draw cornea
        ctx.save("translate");
        ctx.strokeStyle = "yellow";
        ctx.translate(edgeCornea.x, edgeCornea.y);
        ctx.beginPath();
        ctx.arc(0, 0, edgeCornea.r, (20 / 180.0) * Math.PI, (-20 / 180.0) * Math.PI, true);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(
          0,
          0,
          edgeCornea.r,
          (20 / 180.0) * Math.PI + Math.PI,
          (-20 / 180.0) * Math.PI + Math.PI,
          true
        );
        ctx.stroke();
        ctx.lineWidth = 3;
        ctx.setLineDash([6, 5]);
        ctx.beginPath();
        ctx.moveTo(-20, 0);
        ctx.lineTo(20, 0);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(0, -20);
        ctx.lineTo(0, 20);
        ctx.stroke();
        ctx.restore("translate");
      }
      // ctx.fillStyle = '#0f0'
      // let txt =` X: ${data.pupil.x} , Y: ${data.pupil.y} R: ${data.pupil.r}`
      // ctx.fillText(this.$t('langcfg.txtPupil') + txt, 20, 80)

      // ctx.fillStyle = 'yellow'
      // txt =` X: ${data.cornea.x} , Y: ${data.cornea.y} R: ${data.cornea.r}`
      // ctx.fillText(this.$t('langcfg.txtCornea') + txt, 20, 180)
      return canvas.toDataURL();
    },
    getCheckTime() {
      if (this.isContentValid("topography")) {
        return formatDate(
          this.record.content[`data${this.currentEye}`].topography.testtime,
          this.dateFormat,
          true
        );
      } else if (this.isNewPupil) {
        let key = this.isContentValid("pupilcorneadia_dark")
          ? "pupilcorneadia_dark"
          : this.isContentValid("pupilcorneadia_lowerMiddle")
            ? "pupilcorneadia_lowerMiddle"
            : this.isContentValid("pupilcorneadia_middle")
              ? "pupilcorneadia_middle"
              : this.isContentValid("pupilcorneadia_bright")
                ? "pupilcorneadia_bright"
                : "pupilcorneadia_dynamic";
        return formatDate(
          this.record.content[`data${this.currentEye}`][key].testtime,
          this.dateFormat,
          true
        );
      }
      return "";
    },
    normalPatientInfo(data) {
      let age = jsGetAge(this.patient.birthday);
      data.patientInfo.name = getFullName(this.patient);
      data.patientInfo.pid = this.patient.pid;
      data.patientInfo.sex =
        this.patient.sex === "M"
          ? this.$t("langcfg.txtMale")
          : this.patient.sex === "F"
            ? this.$t("langcfg.txtFemale")
            : this.patient.sex === "O"
              ? this.$t("langcfg.txtSexOther")
              : this.patient.sex === "U"
                ? this.$t("langcfg.txtSexUnknown")
                : "";
      data.patientInfo.age = age < 0 ? "" : age;
      data.patientInfo.birthday = this.patient.birthday;
      data.patientInfo.checkDate = this.getCheckTime();
    },
    normalXYInMap(v, ratio, isY = false) {
      return isY ? -1 * v * ratio : v * ratio;
    },
    normalMinMaxVals(vals) {
      let _points = [];
      if (isDefined(vals)) {
        vals.px.map((item, index) => {
          if (
            isDataValid(item) &&
            isDefined(vals.py) &&
            isDefined(vals.pz) &&
            isDataValid(vals.pz[index])
          ) {
            _points.push({
              x: item,
              y: vals.py[index],
              value: isDataValid(vals.pz[index]) ? vals.pz[index]._toFixed(1) : ""
            });
          }
        });
      }
      return _points;
    },
    calcMaxMinStartPoint(endX, endY, radius, ratio) {
      let angle = Math.atan2(endX, endY);
      let r = radius === 0 ? 1.5 : radius + 1;
      let point = {
        start: {
          x: this.normalXYInMap(radius * Math.cos(Math.PI / 2 - angle), ratio),
          y: this.normalXYInMap(radius * Math.sin(Math.PI / 2 - angle), ratio, true)
        },

        end: {
          x: this.normalXYInMap(r * Math.cos(Math.PI / 2 - angle), ratio),
          y: this.normalXYInMap(r * Math.sin(Math.PI / 2 - angle), ratio, true)
        },
        isHorizon: Math.abs(angle) < Math.PI / 4 || Math.abs(angle) > (Math.PI * 3) / 4
      };
      return point;
    },
    getColor(flag) {
      return flag ? FLATCOLOR : STEEPCOLOR;
    },
    drawMaxMinVals(ctx, points, ratio) {
      ctx.beginPath();
      ctx.lineWidth = 6;
      let innerR = 0;
      let r = 601 / 2.0;
      let size = this.measureText(ctx, "");
      let w = size.width;
      let h = size.height;
      let cnt = 0;
      points.map((item, index) => {
        if (index === 0) {
          innerR = 0;
        } else if (index % 4 === 0) {
          innerR = innerR === 0 ? 1.5 : innerR + 1;
        }
        if (cnt === 4) {
          cnt = 0;
        }
        let point = this.calcMaxMinStartPoint(item.x, item.y, innerR, ratio);
        if (isPointInCircle(point.end.x, point.end.y, r)) {
          ctx.beginPath();
          ctx.lineWidth = 8;
          ctx.strokeStyle = "red";
          ctx.moveTo(point.start.x, point.start.y);
          ctx.lineTo(point.end.x, point.end.y);
          ctx.stroke();
          ctx.beginPath();
          ctx.lineWidth = 6;
          ctx.strokeStyle = this.getColor(cnt < 2);
          ctx.moveTo(point.start.x, point.start.y);
          ctx.lineTo(point.end.x, point.end.y);
          ctx.stroke();
          let text = item.value;
          if (text && text.length > 0) {
            w = this.measureText(ctx, text).width;
            let oy = point.isHorizon ? h + 4 : 0;
            ctx.fillStyle = "black";
            ctx.fillRect(
              (point.start.x + point.end.x) / 2 - w / 2 - 2,
              (point.start.y + point.end.y) / 2 - h - 4 + oy,
              w + 8,
              h + 8
            );
            ctx.fillStyle = this.getColor(cnt < 2);
            ctx.fillText(
              text,
              (point.start.x + point.end.x) / 2 - w / 2,
              (point.start.y + point.end.y) / 2 + oy
            );
          }
        }
        cnt++;
      });
    },

    drawMaxMin(ctx, ratio, values, dia) {
      if (!isDefined(values) || values.length <= 0) return false;
      let size = this.measureText(ctx, "");
      let w = size.width;
      let h = size.height;
      ctx.save("translate");
      ctx.strokeStyle = ctx.fillStyle = "black";
      let r = 601 / 2.0;
      for (let id = 1; id <= dia / 2; id++) {
        if (this.normalXYInMap(id, ratio) < r) {
          ctx.beginPath();
          let i = id + 0.5;
          let text = (i * 2).toString();
          size = this.measureText(ctx, text);
          w = size.width;
          h = size.height;
          let offsetAngle = Math.atan2(h / 2 + 5, this.normalXYInMap(i, ratio));
          ctx.fillText(text, this.normalXYInMap(i, ratio, true) - w / 2, h / 2);
          ctx.fillText(text, this.normalXYInMap(i, ratio) - w / 2, h / 2);
          // 绘制弧
          ctx.beginPath();
          ctx.arc(0, 0, this.normalXYInMap(i, ratio), offsetAngle, Math.PI * 2);
          ctx.stroke();
          ctx.beginPath();
          ctx.arc(0, 0, this.normalXYInMap(i, ratio) - offsetAngle, Math.PI * 2, true);
          ctx.stroke();
        }
      }
      let _values = this.normalMinMaxVals(values);
      this.drawMaxMinVals(ctx, _values, ratio);
      ctx.restore("translate");
      return true;
    },
    normalNumValuesPoints(pointsX, pointsY, pointsZ = null, ratio, fixed = 2) {
      let _points = [];
      let pointsLen = pointsZ.length;
      for (let i = 0; i < pointsLen; i++) {
        if (isDataValid(pointsX[i]) && isDataValid(pointsY[i])) {
          if (!isDefined(pointsZ) || (isDefined(pointsZ) && isDataValid(pointsZ[i]))) {
            _points.push({
              x: this.normalXYInMap(pointsX[i], ratio),
              y: this.normalXYInMap(pointsY[i], ratio, true),
              value: isDefined(pointsZ) ? pointsZ[i]._toFixed(fixed) : null
            });
          }
        }
      }
      return _points;
    },
    measureText(ctx, str) {
      let w = ctx.measureText(str).width;
      let h = ctx.measureText("Z").width;
      return {
        width: w,
        height: h
      };
    },
    drawNumVals(ctx, ratio, values, fix) {
      if (!isDefined(values) || values.length <= 0) return false;
      ctx.save("translate");
      ctx.fillStyle = "black";
      let points = this.normalNumValuesPoints(values.px, values.py, values.pz, ratio, fix);
      let size = this.measureText(ctx, "");
      let w = size.width;
      let h = size.height;
      let radius = 601 / 2.0;
      points.map((item, index) => {
        w = this.measureText(ctx, item.value).width;
        if (isPointInCircle(item.x, item.y, radius)) {
          ctx.fillText(item.value, item.x - w / 2.0, item.y + h / 2.0);
        }
      });
      ctx.restore("translate");
      return true;
    },
    draw3579mmRings(ctx, ratio) {
      ctx.save("translate");
      ctx.fillStyle = "black";
      ctx.strokeStyle = "black";
      let arr = [3, 5, 7, 9];
      arr.forEach((e) => {
        ctx.beginPath();
        ctx.arc(0, 0, (ratio * e) / 2, 0, Math.PI * 2);
        ctx.stroke();
      });
      ctx.restore("translate");
    },
    drawApexPosition(ctx, ratio) {
      function _dataInMap(v, isY = false) {
        return isY ? -1 * v * ratio : v * ratio;
      }
      function isDataValid(v) {
        return !isEqual(v, -1000, 0.0001);
      }
      function _isPositionXYValid(...args) {
        for (let i = 0; i < args.length; i++) {
          if (!isDefined(args[i]) || !isDataValid(args[i].value)) return false;
          else return true;
        }
      }
      const { PachyApexX, PachyApexY } = { PachyApexX: { value: 0 }, PachyApexY: { value: 0 } };
      if (_isPositionXYValid(PachyApexX, PachyApexY)) {
        ctx.save("translate");
        let x = _dataInMap(PachyApexX.value);
        let y = _dataInMap(PachyApexY.value, true);
        const len = 26;
        ctx.beginPath();
        ctx.fillStyle = "white";
        ctx.arc(x, y, len / 2, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore("translate");
      }
    },
    drawMinRadiusF(ctx, ratio) {
      function _dataInMap(v, isY = false) {
        return isY ? -1 * v * ratio : v * ratio;
      }
      function isDataValid(v) {
        return !isEqual(v, -1000, 0.0001);
      }
      function _isPositionXYValid(...args) {
        for (let i = 0; i < args.length; i++) {
          if (!isDefined(args[i]) || !isDataValid(args[i].value)) return false;
          else return true;
        }
      }
      const { RminX, RminY } = this.mapValues.params;
      if (_isPositionXYValid(RminX, RminY)) {
        ctx.save("translate");
        let x = _dataInMap(RminX.value);
        let y = _dataInMap(RminY.value, true);
        const len = 26;
        ctx.beginPath();
        ctx.fillStyle = "white";
        ctx.moveTo(-len / 2 + x, y);
        ctx.lineTo(x, -len / 2 + y);
        ctx.lineTo(len / 2 + x, y);
        ctx.lineTo(x, len / 2 + y);
        ctx.closePath();
        ctx.fill();
        ctx.restore("translate");
      }
    },
    renderAxis(id, dia = 12) {
      return;
      let canvas = document.createElement("canvas");
      // canvas.style.visibility = 'hidden'
      canvas.style.width = "651px";
      canvas.style.height = "651px";

      canvas.width = 651;
      canvas.height = 651;
      let ctx = canvas.getContext("2d");
      const padding = 30;
      let center = {
        x: canvas.width / 2.0,
        y: canvas.width / 2.0
      };
      ctx.translate(center.x, center.y);
      let fontsize = 20;
      ctx.font = `${fontsize}px arial`;
      const scale = (canvas.width - 2 * padding) / dia;
      // ---------------
      let x = 0;
      let y = 0;

      // 绘制X轴
      ctx.beginPath();
      ctx.moveTo((-scale * dia) / 2, center.y - padding);
      ctx.lineTo((scale * dia) / 2, center.y - padding);
      ctx.stroke();
      const len = Math.floor(dia / 2);

      for (let idx = 0; idx <= len; idx++) {
        ctx.beginPath();
        x = idx * scale;
        y = center.y - padding;
        let txt = idx.toString();
        const scaleH = 5;
        let fontW = ctx.measureText(txt).width;
        let fontH = 2 * fontW;
        ctx.strokeStyle = "black";
        ctx.moveTo(x, y);
        ctx.lineTo(x, y + scaleH);
        ctx.stroke();
        ctx.fillText(txt, x - fontW / 2, y + fontH + scaleH);
        if (idx !== 0) {
          ctx.beginPath();
          ctx.moveTo(-x, y);
          ctx.lineTo(-x, y + 5);
          ctx.stroke();
          txt = `-${idx}`;
          let fontW = ctx.measureText(txt).width;
          ctx.fillText(txt, -x - fontW / 2, y + fontH + scaleH);
        }
      }
      //   绘制Y轴
      ctx.beginPath();
      ctx.moveTo((-scale * dia) / 2, -center.y + padding);
      ctx.lineTo((-scale * dia) / 2, center.y - padding);
      ctx.stroke();

      for (let idy = 0; idy <= len; idy++) {
        ctx.beginPath();
        x = center.x;
        y = idy * scale;
        let txt = idy.toString();
        const scaleH = 5;
        let fontW = ctx.measureText(txt).width;
        let fontH = fontW;
        ctx.moveTo(-x + padding, -y);
        ctx.lineTo(-x + padding - scaleH, -y);
        ctx.stroke();
        ctx.fillText(txt, -x + padding - fontW * 1.5 - scaleH, -y + fontH / 2);
        if (idy !== 0) {
          ctx.beginPath();
          ctx.moveTo(-x + padding, y);
          ctx.lineTo(-x + padding - scaleH, y);
          ctx.stroke();
          txt = `-${idy}`;
          let fontW = ctx.measureText(txt).width;
          ctx.fillText(txt, -x + padding - fontW - scaleH * 1.5, y + fontH / 2);
        }
      }
      // 绘制大圆
      ctx.save();
      let r = (dia / 2) * scale;
      ctx.beginPath();
      ctx.arc(0, 0, r, 0, 2 * Math.PI);
      ctx.stroke();
      let w = ctx.measureText("").width;
      // 绘制圆上的刻度
      ctx.rotate(0.5 * Math.PI);
      for (let id = 0; id < 360; id += 15) {
        ctx.beginPath();
        if (id % 30 === 0) {
          w = ctx.measureText(id + "°").width;
          ctx.fillText(id + "°", -w / 2, -r - 8);
        }
        ctx.moveTo(0, -r);
        ctx.lineTo(0, -r - 5);
        ctx.stroke();
        ctx.rotate((-15 * Math.PI) / 180);
      }
      return canvas.toDataURL();
    },
    renderMapValues(dia = 9, numVals, minMaxVals, mapstyle, shapes = {}) {
      dia = 12;
      let canvas = document.createElement("canvas");
      canvas.width = 601;
      canvas.height = 601;
      canvas.style.width = "601px";
      canvas.style.height = "601px";
      canvas.style.visibility = "hidden";
      let ctx = canvas.getContext("2d");
      let center = canvas.width / 2.0;
      ctx.translate(center, center);
      let fontsize = 20;
      ctx.font = `${fontsize}px arial`;
      let ratio = canvas.width / dia;
      let fix = mapstyle === MAPSTYLES.ElevationF ? 0 : 2;
      if (shapes.Show3579Ring) {
        this.draw3579mmRings(ctx, ratio);
      }
      if (shapes.ShowApexPosition) {
        this.drawApexPosition(ctx, ratio);
      }
      if (shapes.ShowMinRadiusF) {
        this.drawMinRadiusF(ctx, ratio);
      }
      let resultNumVals = this.drawNumVals(ctx, ratio, numVals, fix);
      let resultMinMaxVals = this.drawMaxMin(ctx, ratio, minMaxVals, dia);
      if (
        resultNumVals ||
        resultMinMaxVals ||
        shapes.Show3579Ring ||
        shapes.ShowApexPosition ||
        shapes.ShowMinRadiusF
      ) {
        return canvas.toDataURL();
      }
      return "";
    },
    normalKeratoconus(data) {
      if (data.topography.reportName.includes("keratoconus") && !window.__ct__.debug) {
        let keratoconusDrawSettings = window.mapDrawSettings.keratoconus;
        let dia = 12;
        if (
          this.record &&
          this.record.content[`data${this.currentEye}`]["topography"] &&
          this.record.content[`data${this.currentEye}`]["topography"].diagnosed
        ) {
          genReportMap = new GenReportMap(this.$store.state.topography.casePath, 0xffffffff);

          let obj = genReportMap.getMap(MAPSTYLES.SCurvatureF, 0);
          data.keratoconus.sCurvature.map = obj.mapURL;
          data.keratoconus.sCurvature.colorBarURL = obj.colorBarURL;
          if (keratoconusDrawSettings.mapInForm0.shapes.ShowNumericValues) {
            data.keratoconus.sCurvature.numVals = obj.numVals;
          }
          if (keratoconusDrawSettings.mapInForm0.shapes.ShowMaxMin) {
            data.keratoconus.sCurvature.minMaxVals = obj.minMaxVals;
          }
          dia = keratoconusDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12;
          data.keratoconus.sCurvature.numValsMap = this.renderMapValues(
            dia,
            data.keratoconus.sCurvature.numVals,
            data.keratoconus.sCurvature.minMaxVals,
            MAPSTYLES.SCurvatureF,
            keratoconusDrawSettings.mapInForm0.shapes
          );

          obj = genReportMap.getMap(MAPSTYLES.ElevationF, 1);
          data.keratoconus.elevation.map = obj.mapURL;
          data.keratoconus.elevation.colorBarURL = obj.colorBarURL;
          if (keratoconusDrawSettings.mapInForm1.shapes.ShowNumericValues) {
            data.keratoconus.elevation.numVals = obj.numVals;
          }
          if (keratoconusDrawSettings.mapInForm1.shapes.ShowMaxMin) {
            data.keratoconus.elevation.minMaxVals = obj.minMaxVals;
          }
          dia = keratoconusDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? 9 : 12;
          data.keratoconus.elevation.numValsMap = this.renderMapValues(
            dia,
            data.keratoconus.elevation.numVals,
            data.keratoconus.elevation.minMaxVals,
            MAPSTYLES.ElevationF,
            keratoconusDrawSettings.mapInForm1.shapes
          );
        } else {
          data.printFlags.reportName = data.printFlags.reportName.map((moduleName) =>
            moduleName === "keratoconus" ? "" : moduleName
          );
        }
      }
    },
    normalFourMaps(data) {
      if (data.topography.reportName.includes("fourmaps") && !window.__ct__.debug) {
        let fourmapsDrawSettings = window.mapDrawSettings.fourmaps;
        let dia = 12;
        if (
          this.record &&
          this.record.content[`data${this.currentEye}`]["topography"] &&
          this.record.content[`data${this.currentEye}`]["topography"].diagnosed
        ) {
          genReportMap = new GenReportMap(this.$store.state.topography.casePath, 0xffffffff);
          let obj = genReportMap.getMap(MAPSTYLES.TCurvatureF, 0);
          data.fourMaps.tCurvature.map = obj.mapURL;
          data.fourMaps.tCurvature.colorBarURL = obj.colorBarURL;
          if (fourmapsDrawSettings.mapInForm0.shapes.ShowNumericValues) {
            data.fourMaps.tCurvature.numVals = obj.numVals;
          }
          if (fourmapsDrawSettings.mapInForm0.shapes.ShowMaxMin) {
            data.fourMaps.tCurvature.minMaxVals = obj.minMaxVals;
          }
          dia = fourmapsDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12;
          data.fourMaps.tCurvature.numValsMap = this.renderMapValues(
            dia,
            data.fourMaps.tCurvature.numVals,
            data.fourMaps.tCurvature.minMaxVals,
            MAPSTYLES.TCurvatureF,
            fourmapsDrawSettings.mapInForm0.shapes
          );
          data.fourMaps.tCurvature.axisMap = this.renderAxis(dia);

          obj = genReportMap.getMap(MAPSTYLES.SCurvatureF, 1);
          data.fourMaps.sCurvature.map = obj.mapURL;
          data.fourMaps.sCurvature.colorBarURL = obj.colorBarURL;
          if (fourmapsDrawSettings.mapInForm1.shapes.ShowNumericValues) {
            data.fourMaps.sCurvature.numVals = obj.numVals;
          }
          if (fourmapsDrawSettings.mapInForm1.shapes.ShowMaxMin) {
            data.fourMaps.sCurvature.minMaxVals = obj.minMaxVals;
          }
          dia = fourmapsDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? 9 : 12;
          data.fourMaps.sCurvature.numValsMap = this.renderMapValues(
            dia,
            data.fourMaps.sCurvature.numVals,
            data.fourMaps.sCurvature.minMaxVals,
            MAPSTYLES.SCurvatureF,
            fourmapsDrawSettings.mapInForm1.shapes
          );
          data.fourMaps.sCurvature.axisMap = this.renderAxis(dia);
          obj = genReportMap.getMap(MAPSTYLES.ElevationF, 2);
          data.fourMaps.elevation.map = obj.mapURL;
          data.fourMaps.elevation.colorBarURL = obj.colorBarURL;
          if (fourmapsDrawSettings.mapInForm2.shapes.ShowNumericValues) {
            data.fourMaps.elevation.numVals = obj.numVals;
          }
          if (fourmapsDrawSettings.mapInForm2.shapes.ShowMaxMin) {
            data.fourMaps.elevation.minMaxVals = obj.minMaxVals;
          }
          dia = fourmapsDrawSettings.mapInForm2.shapes.ShowDiameter9mm ? 9 : 12;
          data.fourMaps.elevation.numValsMap = this.renderMapValues(
            dia,
            data.fourMaps.elevation.numVals,
            data.fourMaps.elevation.minMaxVals,
            MAPSTYLES.ElevationF,
            fourmapsDrawSettings.mapInForm2.shapes
          );
          data.fourMaps.elevation.axisMap = this.renderAxis(dia);
          obj = genReportMap.getMap(MAPSTYLES.FRP, 3, 0xff2d3039);
          data.fourMaps.frp.map = obj.mapURL;
          data.fourMaps.frp.colorBarURL = obj.colorBarURL;
          if (fourmapsDrawSettings.mapInForm3.shapes.ShowNumericValues) {
            data.fourMaps.frp.numVals = obj.numVals;
          }
          if (fourmapsDrawSettings.mapInForm3.shapes.ShowMaxMin) {
            data.fourMaps.frp.minMaxVals = obj.minMaxVals;
          }
          dia = fourmapsDrawSettings.mapInForm3.shapes.ShowDiameter9mm ? 9 : 12;
          data.fourMaps.frp.numValsMap = this.renderMapValues(
            dia,
            data.fourMaps.frp.numVals,
            data.fourMaps.frp.minMaxVals,
            MAPSTYLES.FRP,
            fourmapsDrawSettings.mapInForm3.shapes
          );
          data.fourMaps.frp.axisMap = this.renderAxis(dia);
        } else {
          data.printFlags.reportName = data.printFlags.reportName.map((moduleName) =>
            moduleName === "fourmaps" ? "" : moduleName
          );
        }
      }
    },
    normalZernike(data) {
      let maxPeak = { x: "--", y: "--" };
      let meanRms = { mean: "--", rms: "--" };
      if (data.topography.reportName.includes("zernike") && !window.__ct__.debug) {
        if (
          this.record &&
          this.record.content[`data${this.currentEye}`]["topography"] &&
          this.record.content[`data${this.currentEye}`]["topography"].diagnosed
        ) {
          if (!isDefined(genReportMap)) {
            genReportMap = new GenReportMap(this.$store.state.topography.casePath, 0xffffffff);
          }
          let result = genReportMap.getZernikeImgs();
          let vals = [];
          if (isDefined(result)) {
            if (isDefined(result.values)) {
              for (let id = 0; id < result.values.length; id++) {
                if (isDataValid(result.values[id])) {
                  result.values[id] *= 1000;
                  vals.push(result.values[id]._toFixed(2));
                } else {
                  vals.push("--");
                }
              }
            } else {
              vals = new Array(66);
              vals.fill("--");
            }
            if (isDefined(result.maxPeak)) {
              maxPeak.x = isDataValid(result.maxPeak.x) ? result.maxPeak.x._toFixed(2) : "--";
              maxPeak.y = isDataValid(result.maxPeak.y) ? result.maxPeak.y._toFixed(2) : "--";
            }
            if (isDefined(result.meanRms)) {
              meanRms.mean = isDataValid(result.meanRms.mean)
                ? result.meanRms.mean._toFixed(2)
                : "--";
              meanRms.rms = isDataValid(result.meanRms.rms) ? result.meanRms.rms._toFixed(2) : "--";
            }
          }
          let scale = 12.0 / window.zernikeSet.diameter;
          let clip = 50 / scale;

          data.aberration = {
            params: window.zernikeParams.params,
            svgPath: fileSys.getCfgPath("img/zernikes/"),
            values: vals,
            zernikeSet: window.zernikeSet,
            map: isDefined(result) ? result.mapURL : "",
            numValsMap: this.renderMapValues(
              window.zernikeSet.diameter,
              isDefined(result) ? result.numVals : null,
              null,
              MAPSTYLES.ElevationF
            ),
            transform: `scale(${scale})`,
            clipPath: `circle(${clip}% at 50% 50%)`,
            maxPeak: maxPeak,
            meanRms: meanRms,
            retinal: {
              image: isDefined(result) && isDefined(result.retinal) ? result.retinal.URL : "",
              title: isDefined(result) && isDefined(result.retinal) ? result.retinal.title : ""
            },
            psf: {
              image: isDefined(result) && isDefined(result.psf) ? result.psf.URL : "",
              title: isDefined(result) && isDefined(result.psf) ? result.psf.title : "",
              label: isDefined(result) && isDefined(result.psf) ? result.psf.label : ""
            },
            chart: {
              image: isDefined(result) && isDefined(result.chart) ? result.chart.URL : "",
              title: isDefined(result) && isDefined(result.chart) ? result.chart.title : ""
            }
          };
        } else {
          data.printFlags.reportName = data.printFlags.reportName.map((moduleName) =>
            moduleName === "zernike" ? "" : moduleName
          );
        }
      }
    },
    normalPupilCornea(data) {
      let isValid =
        this.isContentValid("pupilcorneadia") ||
        this.isContentValid("scotopia") ||
        this.isContentValid("dynamicpupil");
      if (
        (data.topography.reportName.includes("pupilcorneadiameter") &&
          (isValid || this.isNewPupil)) ||
        window.__ct__.debug
      ) {
        console.log(
          "this.record.content[`data${this.currentEye}`]=================",
          this.record.content[`data${this.currentEye}`]
        );
        let coe = window.magecoe.pupilcornea;
        let edgePupil, edgeCornea, edgeDark, edgeLowerMiddle, edgeMiddle, edgeBright;
        let _edge;
        let _edgeMoved;
        if (this.isNewPupil) {
          let _edge;
          let _edgeMoved;
          if (this.isModeDataValid("pupilcorneadia_dark", "pupildia")) {
            _edge =
              this.record.content[`data${this.currentEye}`]["pupilcorneadia_dark"]["pupildia"].edge;
            _edgeMoved =
              this.record.content[`data${this.currentEye}`]["pupilcorneadia_dark"]["pupildia"]
                .edgeMoved;
            edgeDark = isDataValid(_edge.r) ? _edge : _edgeMoved;
            let x =
                isDefined(edgeDark) && isDataValid(edgeDark.x) && isDataValid(edgeDark.rx)
                  ? ((edgeDark.x - edgeDark.rx) * coe * 2)._toFixed(2)
                  : "--",
              y =
                isDefined(edgeDark) && isDataValid(edgeDark.y) && isDataValid(edgeDark.ry)
                  ? ((edgeDark.y - edgeDark.ry) * coe * 2)._toFixed(2)
                  : "--";
            data.pupilCornea.dark = {
              ...reportBino.cartesianToPolar(x, y),
              x: x === "--" ? "--, " : `${x} mm, `,
              y: y === "--" ? "--, " : `${y} mm`,
              r:
                isDefined(edgeDark) && isDataValid(edgeDark.r)
                  ? (edgeDark.r * coe * 2)._toFixed(2)
                  : "--"
            };
          } else {
            data.pupilCornea.dark = {
              x: "--",
              y: "--",
              r: "--",
              radius: "--",
              angleDegrees: "--"
            };
          }
          if (this.isModeDataValid("pupilcorneadia_lowerMiddle", "pupildia")) {
            _edge =
              this.record.content[`data${this.currentEye}`]["pupilcorneadia_lowerMiddle"][
                "pupildia"
              ].edge;
            _edgeMoved =
              this.record.content[`data${this.currentEye}`]["pupilcorneadia_lowerMiddle"][
                "pupildia"
              ].edgeMoved;
            edgeLowerMiddle = isDataValid(_edge.r) ? _edge : _edgeMoved;
            let x =
                isDefined(edgeLowerMiddle) &&
                isDataValid(edgeLowerMiddle.x) &&
                isDataValid(edgeLowerMiddle.rx)
                  ? ((edgeLowerMiddle.x - edgeLowerMiddle.rx) * coe * 2)._toFixed(2)
                  : "--",
              y =
                isDefined(edgeLowerMiddle) &&
                isDataValid(edgeLowerMiddle.y) &&
                isDataValid(edgeLowerMiddle.ry)
                  ? ((edgeLowerMiddle.y - edgeLowerMiddle.ry) * coe * 2)._toFixed(2)
                  : "--";
            data.pupilCornea.lowerMiddle = {
              ...reportBino.cartesianToPolar(x, y),
              x: x === "--" ? "--, " : `${x} mm, `,
              y: y === "--" ? "--, " : `${y} mm`,
              r:
                isDefined(edgeLowerMiddle) && isDataValid(edgeLowerMiddle.r)
                  ? (edgeLowerMiddle.r * coe * 2)._toFixed(2)
                  : "--"
            };
          } else {
            data.pupilCornea.lowerMiddle = {
              x: "--",
              y: "--",
              r: "--",
              radius: "--",
              angleDegrees: "--"
            };
          }
          if (this.isModeDataValid("pupilcorneadia_middle", "pupildia")) {
            _edge =
              this.record.content[`data${this.currentEye}`]["pupilcorneadia_middle"]["pupildia"]
                .edge;
            _edgeMoved =
              this.record.content[`data${this.currentEye}`]["pupilcorneadia_middle"]["pupildia"]
                .edgeMoved;
            edgeMiddle = isDataValid(_edge.r) ? _edge : _edgeMoved;
            let x =
                isDefined(edgeMiddle) && isDataValid(edgeMiddle.x) && isDataValid(edgeMiddle.rx)
                  ? ((edgeMiddle.x - edgeMiddle.rx) * coe * 2)._toFixed(2)
                  : "--",
              y =
                isDefined(edgeMiddle) && isDataValid(edgeMiddle.y) && isDataValid(edgeMiddle.ry)
                  ? ((edgeMiddle.y - edgeMiddle.ry) * coe * 2)._toFixed(2)
                  : "--";
            data.pupilCornea.middle = {
              ...reportBino.cartesianToPolar(x, y),
              x: x === "--" ? "--, " : `${x} mm, `,
              y: y === "--" ? "--, " : `${y} mm`,
              r:
                isDefined(edgeMiddle) && isDataValid(edgeMiddle.r)
                  ? (edgeMiddle.r * coe * 2)._toFixed(2)
                  : "--"
            };
          } else {
            data.pupilCornea.middle = {
              x: "--",
              y: "--",
              r: "--",
              radius: "--",
              angleDegrees: "--"
            };
          }
          if (this.isModeDataValid("pupilcorneadia_bright", "pupildia")) {
            _edge =
              this.record.content[`data${this.currentEye}`]["pupilcorneadia_bright"]["pupildia"]
                .edge;
            _edgeMoved =
              this.record.content[`data${this.currentEye}`]["pupilcorneadia_bright"]["pupildia"]
                .edgeMoved;
            edgeBright = isDataValid(_edge.r) ? _edge : _edgeMoved;
            let x =
                isDefined(edgeBright) && isDataValid(edgeBright.x) && isDataValid(edgeBright.rx)
                  ? ((edgeBright.x - edgeBright.rx) * coe * 2)._toFixed(2)
                  : "--",
              y =
                isDefined(edgeBright) && isDataValid(edgeBright.y) && isDataValid(edgeBright.ry)
                  ? ((edgeBright.y - edgeBright.ry) * coe * 2)._toFixed(2)
                  : "--";
            data.pupilCornea.bright = {
              ...reportBino.cartesianToPolar(x, y),
              x: x === "--" ? "--, " : `${x} mm, `,
              y: y === "--" ? "--, " : `${y} mm`,
              r:
                isDefined(edgeBright) && isDataValid(edgeBright.r)
                  ? (edgeBright.r * coe * 2)._toFixed(2)
                  : "--"
            };
          } else {
            data.pupilCornea.bright = {
              x: "--",
              y: "--",
              r: "--",
              radius: "--",
              angleDegrees: "--"
            };
          }
          let key = this.isContentValid("pupilcorneadia_dark")
            ? "pupilcorneadia_dark"
            : this.isContentValid("pupilcorneadia_lowerMiddle")
              ? "pupilcorneadia_lowerMiddle"
              : this.isContentValid("pupilcorneadia_middle")
                ? "pupilcorneadia_middle"
                : "pupilcorneadia_bright";
          if (this.isModeDataValid(key, "corneadia")) {
            _edge = this.record.content[`data${this.currentEye}`][key]["corneadia"].edge;
            _edgeMoved = this.record.content[`data${this.currentEye}`][key]["corneadia"].edgeMoved;
            edgeCornea = isDataValid(_edge.r) ? _edge : _edgeMoved;
            let x =
                isDefined(edgeCornea) && isDataValid(edgeCornea.x) && isDataValid(edgeCornea.rx)
                  ? ((edgeCornea.x - edgeCornea.rx) * coe * 2)._toFixed(2)
                  : "--",
              y =
                isDefined(edgeCornea) && isDataValid(edgeCornea.y) && isDataValid(edgeCornea.ry)
                  ? ((edgeCornea.y - edgeCornea.ry) * coe * 2)._toFixed(2)
                  : "--";
            data.pupilCornea.corneadia = {
              ...reportBino.cartesianToPolar(x, y),
              x: x === "--" ? "--, " : `${x} mm, `,
              y: y === "--" ? "--, " : `${y} mm`,
              r:
                isDefined(edgeCornea) && isDataValid(edgeCornea.r)
                  ? (edgeCornea.r * coe * 2)._toFixed(2)
                  : "--"
            };
          } else {
            data.pupilCornea.corneadia = {
              x: "--",
              y: "--",
              r: "--",
              radius: "--",
              angleDegrees: "--"
            };
          }
          if (this.isModeDataValid("pupilcorneadia_dynamic", "pupilArray")) {
            data.pupilCornea.title = this.$t("langcfg.txtDynamicChangesInPupilDiameter");
            data.pupilCornea.seriesData =
              this.record.content[`data${this.currentEye}`]["pupilcorneadia_dynamic"]["pupilArray"];
            Object.assign(
              data.pupilCornea.seriesData,
              reportBino.puilCalDataMed(data.pupilCornea.seriesData)
            );
          }
        } else {
          if (this.isModeDataValid(KEY, "corneadia")) {
            _edge = this.record.content[`data${this.currentEye}`][KEY]["corneadia"].edge;
            _edgeMoved = this.record.content[`data${this.currentEye}`][KEY]["corneadia"].edgeMoved;
            edgeCornea = isDataValid(_edgeMoved.r) ? _edgeMoved : _edge;
            data.pupilCornea.cornea.x =
              isDefined(edgeCornea) && isDataValid(edgeCornea.r)
                ? (edgeCornea.x * coe)._toFixed(2) + " mm,"
                : "--,";
            data.pupilCornea.cornea.y =
              isDefined(edgeCornea) && isDataValid(edgeCornea.y)
                ? (edgeCornea.y * coe)._toFixed(2) + " mm,"
                : "--,";
            data.pupilCornea.cornea.r =
              isDefined(edgeCornea) && isDataValid(edgeCornea.r)
                ? (edgeCornea.r * coe * 2)._toFixed(2) + " mm"
                : "--";
          } else {
            data.pupilCornea.cornea = { x: "--", y: "--", r: "--" };
          }
          if (this.isModeDataValid(KEY, "pupildia")) {
            _edge = this.record.content[`data${this.currentEye}`][KEY]["pupildia"].edge;
            _edgeMoved = this.record.content[`data${this.currentEye}`][KEY]["pupildia"].edgeMoved;
            edgePupil = isDataValid(_edgeMoved.r) ? _edgeMoved : _edge;
            data.pupilCornea.pupil.x =
              isDefined(edgePupil) && isDataValid(edgePupil.r)
                ? (edgePupil.x * coe)._toFixed(2) + " mm, "
                : "--,";
            data.pupilCornea.pupil.y =
              isDefined(edgePupil) && isDataValid(edgePupil.r)
                ? (edgePupil.y * coe)._toFixed(2) + " mm, "
                : "--,";
            data.pupilCornea.pupil.r =
              isDefined(edgePupil) && isDataValid(edgePupil.r)
                ? (edgePupil.r * coe * 2)._toFixed(2) + " mm"
                : "--";
          } else {
            data.pupilCornea.pupil = { x: "--", y: "--", r: "--" };
          }
          this.calcDist(data, edgePupil, edgeCornea);
          if (this.isModeDataValid(KEY, "photos")) {
            let img = this.drawPupilCenter(edgePupil, edgeCornea, data.pupilCornea);
            let photos = this.record.content[`data${this.currentEye}`][KEY]["photos"];
            let photo = photos[0];
            const { serverip, serverport, sslport, serverssl } = window.server || {};
            let protocol = serverssl === 1 ? "https:" : "http:";
            let port = serverssl === 1 ? sslport : serverport;
            data.pupilCornea.image = isDefined(photo)
              ? `${protocol}//${serverip}:${port}/media/${photo.filename}?access_token=${window.token}`
              : "";
            data.pupilCornea.circleImage = img;
          } else {
            data.printFlags.PupilCornea = false;
          }
        }
      } else {
        data.printFlags.reportName = data.printFlags.reportName.map((moduleName) =>
          moduleName === "pupilcorneadiameter" ? "" : moduleName
        );
      }
    },
    normalHeightFAndTFSQ(data) {
      if (data.topography.reportName.includes("heightfandtfsq") && !window.__ct__.debug) {
        let largemapSettings = window.mapDrawSettings.largemap;
        let dia = 12;
        if (
          this.record &&
          this.record.content[`data${this.currentEye}`]["topography"] &&
          this.record.content[`data${this.currentEye}`]["topography"].diagnosed
        ) {
          genReportMap = new GenReportMap(this.$store.state.topography.casePath, 0xffffffff);
          let obj = genReportMap.getMap(MAPSTYLES.HeightF, 0);
          data.heightFAndTFSQ.heightF.map = obj.mapURL;
          data.heightFAndTFSQ.heightF.colorBarURL = obj.colorBarURL;
          if (largemapSettings.mapInForm0.shapes.ShowNumericValues) {
            data.heightFAndTFSQ.heightF.numVals = obj.numVals;
          }
          if (largemapSettings.mapInForm0.shapes.ShowMaxMin) {
            data.heightFAndTFSQ.heightF.minMaxVals = obj.minMaxVals;
          }
          dia = largemapSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12;
          data.heightFAndTFSQ.heightF.numValsMap = this.renderMapValues(
            dia,
            data.heightFAndTFSQ.heightF.numVals,
            data.heightFAndTFSQ.heightF.minMaxVals,
            MAPSTYLES.HeightF,
            largemapSettings.mapInForm0.shapes
          );
          data.heightFAndTFSQ.heightF.axisMap = this.renderAxis(dia);

          obj = genReportMap.getMap(MAPSTYLES.TFSQ, 0);
          data.heightFAndTFSQ.tfsq.map = obj.mapURL;
          data.heightFAndTFSQ.tfsq.colorBarURL = obj.colorBarURL;
          if (largemapSettings.mapInForm0.shapes.ShowNumericValues) {
            data.heightFAndTFSQ.tfsq.numVals = obj.numVals;
          }
          if (largemapSettings.mapInForm0.shapes.ShowMaxMin) {
            data.heightFAndTFSQ.tfsq.minMaxVals = obj.minMaxVals;
          }
          dia = largemapSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12;
          data.heightFAndTFSQ.tfsq.numValsMap = this.renderMapValues(
            dia,
            data.heightFAndTFSQ.tfsq.numVals,
            data.heightFAndTFSQ.tfsq.minMaxVals,
            MAPSTYLES.TFSQ,
            largemapSettings.mapInForm0.shapes
          );
          data.heightFAndTFSQ.tfsq.axisMap = this.renderAxis(dia);
        } else {
          data.printFlags.reportName = data.printFlags.reportName.map((moduleName) =>
            moduleName === "heightfandtfsq" ? "" : moduleName
          );
        }
      }
    },
    normalFourierAnalysis(data) {
      if (data.topography.reportName.includes("fourieranalysis") && !window.__ct__.debug) {
        let fourierAnalysisSettings = window.mapDrawSettings.fourierAnalysis;
        let dia = 12;
        if (
          this.record &&
          this.record.content[`data${this.currentEye}`]["topography"] &&
          this.record.content[`data${this.currentEye}`]["topography"].diagnosed
        ) {
          let calParams = FourierCalculate.Calculate(
            fileSys.combinePath(this.$store.state.topography.casePath, FILES.cartSagf)
          );
          data.fourierAnalysis.paramsSph = calParams.value.paramsSph;
          data.fourierAnalysis.paramsDecent = calParams.value.paramsDecent;
          data.fourierAnalysis.paramsRegular = calParams.value.paramsRegular;
          data.fourierAnalysis.paramsIrregular = calParams.value.paramsIrregular;
          genReportMap = new GenReportMap(this.$store.state.topography.casePath, 0xffffffff);
          let obj = genReportMap.getMap("fourierAnalysis", 0);
          data.fourierAnalysis.sphericalComponent.map = obj.mapURL;
          data.fourierAnalysis.sphericalComponent.colorBarURL = obj.colorBarURL;
          if (fourierAnalysisSettings.mapInForm0.shapes.ShowNumericValues) {
            data.fourierAnalysis.sphericalComponent.numVals = obj.numVals;
          }
          if (fourierAnalysisSettings.mapInForm0.shapes.ShowMaxMin) {
            data.fourierAnalysis.sphericalComponent.minMaxVals = obj.minMaxVals;
          }
          dia = fourierAnalysisSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12;
          data.fourierAnalysis.sphericalComponent.numValsMap = this.renderMapValues(
            dia,
            data.fourierAnalysis.sphericalComponent.numVals,
            null,
            MAPSTYLES.SCurvatureF,
            fourierAnalysisSettings.mapInForm0.shapes
          );
          data.fourierAnalysis.sphericalComponent.axisMap = this.renderAxis(dia);

          obj = genReportMap.getMap("fourierAnalysis", 1);
          data.fourierAnalysis.decentration.map = obj.mapURL;
          data.fourierAnalysis.decentration.colorBarURL = obj.colorBarURL;
          if (fourierAnalysisSettings.mapInForm1.shapes.ShowNumericValues) {
            data.fourierAnalysis.decentration.numVals = obj.numVals;
          }
          if (fourierAnalysisSettings.mapInForm1.shapes.ShowMaxMin) {
            data.fourierAnalysis.decentration.minMaxVals = obj.minMaxVals;
          }
          dia = fourierAnalysisSettings.mapInForm1.shapes.ShowDiameter9mm ? 9 : 12;
          data.fourierAnalysis.decentration.numValsMap = this.renderMapValues(
            dia,
            data.fourierAnalysis.decentration.numVals,
            null,
            MAPSTYLES.SCurvatureF,
            fourierAnalysisSettings.mapInForm1.shapes
          );
          data.fourierAnalysis.decentration.axisMap = this.renderAxis(dia);
          obj = genReportMap.getMap("fourierAnalysis", 3);
          data.fourierAnalysis.regularAstigmatism.map = obj.mapURL;
          data.fourierAnalysis.regularAstigmatism.colorBarURL = obj.colorBarURL;
          if (fourierAnalysisSettings.mapInForm3.shapes.ShowNumericValues) {
            data.fourierAnalysis.regularAstigmatism.numVals = obj.numVals;
          }
          if (fourierAnalysisSettings.mapInForm3.shapes.ShowMaxMin) {
            data.fourierAnalysis.regularAstigmatism.minMaxVals = obj.minMaxVals;
          }
          dia = fourierAnalysisSettings.mapInForm3.shapes.ShowDiameter9mm ? 9 : 12;
          data.fourierAnalysis.regularAstigmatism.numValsMap = this.renderMapValues(
            dia,
            data.fourierAnalysis.regularAstigmatism.numVals,
            null,
            MAPSTYLES.SCurvatureF,
            fourierAnalysisSettings.mapInForm3.shapes
          );
          data.fourierAnalysis.regularAstigmatism.axisMap = this.renderAxis(dia);
          obj = genReportMap.getMap("fourierAnalysis", 4);
          data.fourierAnalysis.irregularity.map = obj.mapURL;
          data.fourierAnalysis.irregularity.colorBarURL = obj.colorBarURL;
          if (fourierAnalysisSettings.mapInForm4.shapes.ShowNumericValues) {
            data.fourierAnalysis.irregularity.numVals = obj.numVals;
          }
          if (fourierAnalysisSettings.mapInForm4.shapes.ShowMaxMin) {
            data.fourierAnalysis.irregularity.minMaxVals = obj.minMaxVals;
          }
          dia = fourierAnalysisSettings.mapInForm4.shapes.ShowDiameter9mm ? 9 : 12;
          data.fourierAnalysis.irregularity.numValsMap = this.renderMapValues(
            dia,
            data.fourierAnalysis.irregularity.numVals,
            null,
            MAPSTYLES.SCurvatureF,
            fourierAnalysisSettings.mapInForm4.shapes
          );
          data.fourierAnalysis.irregularity.axisMap = this.renderAxis(dia);
        } else {
          data.printFlags.reportName = data.printFlags.reportName.map((moduleName) =>
            moduleName === "fourieranalysis" ? "" : moduleName
          );
        }
      }
    },
    calcDiff(mapv1, mapv2) {
      let dataparams = new DataParams();
      dataparams.getBaseParamsDiff(mapv1.params, mapv2.params);
      return {
        params: dataparams.paramsDiff,
        eyetype: ""
      };
    },
    normalCompare2Records(data) {
      if (data.topography.reportName.includes("compare2records")) {
        let compare2recordsDrawSettings = window.mapDrawSettings.compare2records;
        let dia = 12;
        let recordidone, recordidtwo;
        let eyetypeone, eyetypetwo, oneparams, twoparams;
        let Index;
        if (
          this.record &&
          Array.isArray(this.record.contrasts) &&
          this.record.contrasts[0] &&
          this.record.contrasts[1]
        ) {
          data.compare2records.hasCompareData = true;
          recordidone =
            this.record.contrasts[0] && this.record.contrasts[0]._id
              ? this.record.contrasts[0]._id
              : "";
          recordidtwo =
            this.record.contrasts[1] && this.record.contrasts[1]._id
              ? this.record.contrasts[1]._id
              : "";
          eyetypeone =
            this.record.contrasts[0] && this.record.contrasts[0].eyetype
              ? this.record.contrasts[0].eyetype
              : "";
          eyetypetwo =
            this.record.contrasts[1] && this.record.contrasts[1].eyetype
              ? this.record.contrasts[1].eyetype
              : "";
          Index = this.record.contrasts[2] ? this.record.contrasts[2] : 1;
          data.compare2records.contrastParamsOneTitle =
            this.record.contrasts[0] &&
            this.record.contrasts[0].recorddate &&
            this.record.contrasts[0].eyetype
              ? `${this.record.contrasts[0].recorddate} ${this.record.contrasts[0].eyetype}`
              : "";
          data.compare2records.contrastParamsTwoTitle =
            this.record.contrasts[1] && this.record.contrasts[1].label
              ? this.record.contrasts[1].label
              : "";
          data.compare2records.contrastParamsDiffTitle = this.$t(`langcfg.txt${MAPSTYLES[Index]}`);
          oneparams = new DataParams(fileSys.getCasePath(`${recordidone}_${eyetypeone}`));
          twoparams = new DataParams(fileSys.getCasePath(`${recordidtwo}_${eyetypetwo}`));
        } else {
          data.compare2records.hasCompareData = false;
          return;
        }

        let pathone = fileSys.getCasePath(`${recordidone}_${eyetypeone}/${FILES.acdotana}`);
        let pathtwo = fileSys.getCasePath(`${recordidtwo}_${eyetypetwo}/${FILES.acdotana}`);

        let settings = this.dataShowSettings;
        if (isFileExists(pathone)) {
          oneparams.getBaseParams();
          oneparams.getMajMedian(settings.medianMode);
          oneparams.params.EccPEQ.value = oneparams.getOneMajMedian(settings.mm);
          let objDiff = calcElevDiff(
            fileSys.getCasePath(`${recordidone}_${eyetypeone}`),
            oneparams.params.AxisFlat.value,
            oneparams.params.AxisSteep.value
          );
          oneparams.params.elevDiff4mm.value = objDiff.val;
          oneparams.params.elevDiff4mm.analog = objDiff.analog;
        }
        if (isFileExists(pathtwo)) {
          twoparams.getBaseParams();
          twoparams.getMajMedian(settings.medianMode);
          twoparams.params.EccPEQ.value = twoparams.getOneMajMedian(settings.mm);
          let objDiff = calcElevDiff(
            fileSys.getCasePath(`${recordidtwo}_${eyetypetwo}`),
            twoparams.params.AxisFlat.value,
            twoparams.params.AxisSteep.value
          );
          twoparams.params.elevDiff4mm.value = objDiff.val;
          twoparams.params.elevDiff4mm.analog = objDiff.analog;
        }
        let mapValuesOne = {
          params: oneparams.params,
          eyetypeone
        };
        let mapValuesTwo = {
          params: twoparams.params,
          eyetypetwo
        };
        let mapValuesDiff = this.calcDiff(mapValuesOne, mapValuesTwo);
        data.compare2records.contrastParamsOne = this.normalParamsData(mapValuesOne.params);
        data.compare2records.contrastParamsTwo = this.normalParamsData(mapValuesTwo.params);
        data.compare2records.contrastParamsDiff = this.normalParamsData(mapValuesDiff.params);
        let mapOne = new GenReportMap(
          fileSys.getCasePath(`${recordidone}_${eyetypeone}`),
          0xffffffff
        );
        if (isDefined(recordidone)) {
          let objOne = mapOne.getMap(Index, "compare");
          data.compare2records.contrastone.map = objOne.mapURL;
          data.compare2records.contrastone.colorBarURL = objOne.colorBarURL;
          if (compare2recordsDrawSettings.mapInForm0.shapes.ShowNumericValues) {
            data.compare2records.contrastone.numVals = objOne.numVals;
          }
          if (compare2recordsDrawSettings.mapInForm0.shapes.ShowMaxMin) {
            data.compare2records.contrastone.minMaxVals = objOne.minMaxVals;
          }
          dia = compare2recordsDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12;
          data.compare2records.contrastone.numValsMap = this.renderMapValues(
            dia,
            data.compare2records.contrastone.numVals,
            data.compare2records.contrastone.minMaxVals,
            Index,
            compare2recordsDrawSettings.mapInForm0.shapes
          );
          data.compare2records.contrastone.axisMap = this.renderAxis(dia);
        }

        let mapTwo = new GenReportMap(
          fileSys.getCasePath(`${recordidtwo}_${eyetypetwo}`),
          0xffffffff
        );
        console.log(
          "11111111111111111111111111111111111111",
          fileSys.getCasePath(`${recordidone}_${eyetypeone}`)
        );
        console.log(
          "11111111111111111111111111111111111111",
          fileSys.getCasePath(`${recordidtwo}_${eyetypetwo}`)
        );
        if (isDefined(recordidtwo)) {
          let objTwo = mapTwo.getMap(Index, "compare");
          data.compare2records.contrasttwo.map = objTwo.mapURL;
          data.compare2records.contrasttwo.colorBarURL = objTwo.colorBarURL;
          if (compare2recordsDrawSettings.mapInForm1.shapes.ShowNumericValues) {
            data.compare2records.contrasttwo.numVals = objTwo.numVals;
          }
          if (compare2recordsDrawSettings.mapInForm1.shapes.ShowMaxMin) {
            data.compare2records.contrasttwo.minMaxVals = objTwo.minMaxVals;
          }
          dia = compare2recordsDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? 9 : 12;
          data.compare2records.contrasttwo.numValsMap = this.renderMapValues(
            dia,
            data.compare2records.contrasttwo.numVals,
            data.compare2records.contrasttwo.minMaxVals,
            Index,
            compare2recordsDrawSettings.mapInForm1.shapes
          );
          data.compare2records.contrasttwo.axisMap = this.renderAxis(dia);
        }

        let mapParamsOne = {
          mapIndexInForm: 0,
          mapIndex: Index,
          casePath: fileSys.getCasePath(`${recordidone}_${eyetypeone}`),
          colorBarSize: {
            width: 90,
            height: 600
          }
        };
        let mapParamsTwo = {
          mapIndexInForm: 1,
          mapIndex: Index,
          casePath: fileSys.getCasePath(`${recordidtwo}_${eyetypetwo}`),
          colorBarSize: {
            width: 90,
            height: 600
          }
        };
        let mapDiff = new GenReportMap(this.$store.state.topography.casePath, 0xffffffff);
        if (isDefined(recordidone) && isDefined(recordidtwo)) {
          let objDiff = mapDiff.getDiffMap(mapParamsOne, mapParamsTwo, Index, 2);
          data.compare2records.difference.map = objDiff.mapURL;
          data.compare2records.difference.colorBarURL = objDiff.colorBarURL;
          if (compare2recordsDrawSettings.mapInForm2.shapes.ShowNumericValues) {
            data.compare2records.difference.numVals = objDiff.numVals;
          }
          if (compare2recordsDrawSettings.mapInForm2.shapes.ShowMaxMin) {
            data.compare2records.difference.minMaxVals = objDiff.minMaxVals;
          }
          dia = compare2recordsDrawSettings.mapInForm2.shapes.ShowDiameter9mm ? 9 : 12;
          data.compare2records.difference.numValsMap = this.renderMapValues(
            dia,
            data.compare2records.difference.numVals,
            data.compare2records.difference.minMaxVals,
            Index,
            compare2recordsDrawSettings.mapInForm2.shapes
          );
          data.compare2records.difference.axisMap = this.renderAxis(dia);
        }
      } else {
        data.printFlags.reportName = data.printFlags.reportName.map((moduleName) =>
          moduleName === "compare2records" ? "" : moduleName
        );
      }
    },
    calcDist(data, pupil, cornea) {
      try {
        if (isDefined(pupil) && isDefined(cornea)) {
          data.pupilCornea.dist =
            (
              Math.sqrt(Math.pow(pupil.x - cornea.x, 2) + Math.pow(pupil.y - cornea.y, 2)) *
              window.magecoe.pupilcornea
            )._toFixed(2) + " mm";
        }
      } catch (e) {
        data.pupilCornea.dist = "--";
      }
    },
    didFinishedLoad() {
      this.isBtnEnabled = true;
    },
    normalReportData() {
      try {
        let data = this.initData();
        this.normalPatientInfo(data);
        this.normalFourMaps(data);
        this.normalZernike(data);
        this.normalKeratoconus(data);
        this.normalPupilCornea(data);
        this.normalHeightFAndTFSQ(data);
        this.normalFourierAnalysis(data);
        this.normalCompare2Records(data);
        return data;
      } catch (e) {
        console.log("normalData:", e);
      }
    }
  },
  async mounted() {
    this.$bus.$on("exit-report", () => {
      this.isBtnEnabled = false;
      this.$emit("show-waiting", this.$t("langcfg.txtLoading"), null, true);
      setTimeout(() => this.loadReport(), 1000);
    });
    dicom.on("dicom-ok", () => {
      this.message(this.$t("langcfg.txtUploadPdfSuccess"), "success", 2000);
      dicom.clearDicomPath(() => {
        this.afterBtnEvent();
      });
    });
    dicom.on("dicom-failed", () => {
      this.message(this.$t("langcfg.txtUploadPdfFailed"), "error", 2000);
      dicom.clearDicomPath(() => {
        this.afterBtnEvent();
      });
    });
    console.log("mounted report");

    clearTimeout(timeout);
    await this.loadReport();
    setTimeout(() => {
      if (
        window.thirdPartySettings &&
        window.thirdPartySettings.auto &&
        window.thirdPartySettings.auto.value &&
        window.thirdpartyScript &&
        this.patient.thirdData &&
        window.settings.thirdparty.copmany === "owl"
      ) {
        let batchNo = this.getBatchNo();
        if (this.record.content["dataOD"] && this.record.content["dataOD"].diagnosed)
          this.record.content["dataOD"].batchNo = batchNo;
        if (this.record.content["dataOS"] && this.record.content["dataOS"].diagnosed)
          this.record.content["dataOS"].batchNo = batchNo;
        this.$bus.$emit(EVENTS.updateData, this.record, {}, {}, () => {});
        this.$bus.$emit(EVENTS.hideGlobalWatting);
        this.beforeBtnEvent(this.$t("langcfg.txtpdf2server"), true);
        let casePath = this.$store.state.topography.casePath;
        if (casePath.indexOf("OS") >= 0)
          casePath = this.$store.state.topography.casePath.replace(/OS(\/|$)/, "OD");
        this.uploadThirdparty("OD", casePath, (res) => {
          if (res.message === "OK" || res.message === "PASS") {
            if (casePath.indexOf("OD") >= 0)
              casePath = this.$store.state.topography.casePath.replace(/OD(\/|$)/, "OS");
            this.uploadThirdparty("OS", casePath, (res) => {
              if (res.message === "OK" || res.message === "PASS") {
                this.uploadIntact(this.record.content[`data${this.currentEye}`].inspectId, batchNo);
              } else {
                this.afterBtnEvent();
              }
            });
          }
        });
      }
    }, 500);
  },
  beforeDestroy() {
    try {
      this.$refs.wviewPrint_brother.removeEventListener("did-finish-load", this.didFinishedLoad);
    } catch (e) {}
  }
};
</script>

<style lang="less" scoped>
.el-button {
  border: 1px solid gray;
  padding: 10px;
  min-width: 70mm;
  height: 70px;
}
.report {
  width: 100%;
  background-color: @page-background;
  padding-bottom: 100px;
  text-align: center;
}
.report-wv {
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: auto;
  resize: none;
  margin: 0 auto;
}
.dialog-footer {
  display: flex;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/Report.vue